/* हिन्दी — Hindi */
const hi = {
  nav: {
    home: 'होम',
    imageConverter: 'इमेज कनवर्टर',
    imageCompressor: 'इमेज कंप्रेसर',
    otherTools: 'अन्य टूल्स',
    resizeImage: 'इमेज रीसाइज़',
    cropImage: 'इमेज क्रॉप',
    photoEditor: 'फोटो एडिटर',
    removeBackground: 'बैकग्राउंड हटाएं',
    watermarkImage: 'वॉटरमार्क',
    qrCodeGenerator: 'QR कोड जनरेटर',
    qrCodeScanner: 'QR कोड स्कैनर',
    aboutUs: 'हमारे बारे में',
    faceBlur: 'फेस ब्लर',
  },
  hero: {
    heading: 'आपको हर इमेज टूल यहां मिलेगा',
    subheading: 'इमेज को कनवर्ट, कंप्रेस, रीसाइज़, क्रॉप, एडिट और ट्रांसफॉर्म करने के मुफ्त ऑनलाइन टूल्स। सारी प्रोसेसिंग आपके ब्राउज़र में होती है — तेज़, निजी और सुरक्षित।',
  },
  tools: {
    compressImage: { title: 'इमेज कंप्रेस करें', desc: 'JPG, PNG, SVG और GIF को स्पेस बचाते हुए और क्वालिटी बनाए रखते हुए कंप्रेस करें।' },
    resizeImage: { title: 'इमेज रीसाइज़ करें', desc: 'प्रतिशत या पिक्सेल से अपने आयाम निर्धारित करें और अपनी इमेज का साइज़ बदलें।' },
    cropImage: { title: 'इमेज क्रॉप करें', desc: 'JPG, PNG या GIF को आसानी से क्रॉप करें।' },
    convertToJpg: { title: 'JPG में कनवर्ट करें', desc: 'PNG, GIF, SVG, WEBP इमेज को बल्क में JPG में कनवर्ट करें।' },
    convertFromJpg: { title: 'JPG से कनवर्ट करें', desc: 'JPG इमेज को PNG और GIF में कनवर्ट करें।' },
    qrCodeGenerator: { title: 'QR कोड जनरेटर', desc: 'URL, टेक्स्ट, WiFi, कॉन्टैक्ट्स के लिए कस्टम QR कोड बनाएं।' },
    qrCodeScanner: { title: 'QR कोड स्कैनर', desc: 'अपने कैमरे से या इमेज अपलोड करके तुरंत QR कोड स्कैन करें।' },
    blurFace: { title: 'फेस ब्लर करें', desc: 'प्राइवेसी के लिए अपनी इमेज में चेहरों को ऑटोमैटिकली ब्लर करें।' },
    removeBackground: { title: 'बैकग्राउंड हटाएं', desc: 'उच्च सटीकता के साथ इमेज बैकग्राउंड को तेज़ी से हटाएं।' },
    watermarkImage: { title: 'वॉटरमार्क', desc: 'सेकंडों में अपनी इमेज पर इमेज या टेक्स्ट लगाएं।' },
  },
  whyChoose: {
    label: 'हमें क्यों चुनें',
    heading: 'इमेज एडिट करने का स्मार्ट तरीका',
    subheading: 'दुनिया भर में हज़ारों क्रिएटर्स, डिज़ाइनर्स और डेवलपर्स का भरोसा।',
    reasons: {
      fast: { title: 'बिजली की गति', desc: 'सारी प्रोसेसिंग सीधे आपके ब्राउज़र में होती है। बाहरी सर्वर पर कोई अपलोड नहीं।' },
      private: { title: '100% निजी और सुरक्षित', desc: 'आपकी फाइलें कभी आपके डिवाइस से बाहर नहीं जातीं।' },
      noLimits: { title: 'कोई सीमा नहीं, कोई साइनअप नहीं', desc: 'हर टूल जितनी बार चाहें इस्तेमाल करें — पूरी तरह मुफ्त।' },
      quality: { title: 'प्रोफेशनल क्वालिटी', desc: 'हमारे एल्गोरिदम प्रोफेशनल-ग्रेड रिजल्ट देते हैं।' },
      batch: { title: 'बैच प्रोसेसिंग', desc: 'एक साथ कई फाइलें हैंडल करें।' },
      everywhere: { title: 'हर जगह काम करता है', desc: 'डेस्कटॉप, टैबलेट और मोबाइल पर काम करने वाला रिस्पॉन्सिव डिज़ाइन।' },
    },
    stats: {
      imagesProcessed: 'इमेज प्रोसेस की गईं',
      countriesServed: 'देशों में सेवा',
      uptime: 'अपटाइम',
      freeTools: 'मुफ्त टूल्स',
    },
  },
  footer: {
    tagline: 'मुफ्त ऑनलाइन इमेज टूल्स — सेकंडों में अपनी इमेज कनवर्ट, कंप्रेस, रीसाइज़, क्रॉप और एडिट करें। साइनअप की ज़रूरत नहीं।',
    imageTools: 'इमेज टूल्स',
    moreTools: 'और टूल्स',
    company: 'कंपनी',
    contact: 'संपर्क',
    allRightsReserved: 'सर्वाधिकार सुरक्षित।',
    privacyPolicy: 'गोपनीयता नीति',
    termsOfService: 'सेवा की शर्तें',
  },
  faq: {
    badge: 'FAQ',
    heading: 'अक्सर पूछे जाने वाले प्रश्न',
    subheading: 'इस टूल के बारे में सामान्य प्रश्नों के त्वरित उत्तर।',
    stillHaveQuestions: 'अभी भी सवाल हैं? हम मदद के लिए यहां हैं!',
    reachOut: 'हमारी टीम से संपर्क करें',
    questionHeader: 'प्रश्न',
  },

  contactForm: {
    badge: 'संपर्क करें',
    title: 'हमसे संपर्क करें',
    subtitle: 'हमें आपसे सुनना अच्छा लगेगा। हमें एक संदेश भेजें!',
    nameLabel: 'नाम',
    namePlaceholder: 'आपका पूरा नाम',
    emailLabel: 'ईमेल',
    emailPlaceholder: 'aap@gmail.com',
    subjectLabel: 'विषय',
    subjectPlaceholder: 'यह किस बारे में है?',
    messageLabel: 'संदेश',
    messagePlaceholder: 'अपना संदेश यहाँ लिखें…',
    errName: 'नाम आवश्यक है',
    errEmail: 'ईमेल आवश्यक है',
    errEmailInvalid: 'वैध ईमेल दर्ज करें',
    errSubject: 'विषय आवश्यक है',
    errMessage: 'संदेश आवश्यक है',
    sending: 'भेजा जा रहा है…',
    send: 'संदेश भेजें',
    successTitle: 'संदेश भेजा गया!',
    successMsg: 'संपर्क करने के लिए धन्यवाद। हम जल्द ही आपसे संपर्क करेंगे।',
    sendAnother: 'दूसरा संदेश भेजें',
    sendError: 'कुछ गलत हो गया। कृपया पुनः प्रयास करें।',
  },

  about: {
    label: 'हमारे बारे में',
    heading: 'क्रिएटर्स के लिए, क्रिएटर्स द्वारा',
    subheading: 'हम मानते हैं कि शक्तिशाली इमेज टूल्स मुफ्त, तेज़ और सभी के लिए सुलभ होने चाहिए।',
    missionTitle: 'हमारा मिशन',
    missionText: 'photremium.com एक सरल लक्ष्य के साथ बनाया गया था: वेब पर सबसे सहज, तेज़ और सबसे निजी इमेज एडिटिंग अनुभव प्रदान करना।',
    privacyTitle: 'गोपनीयता पहले',
    privacyText: 'हम कभी भी आपकी इमेज को रिमोट सर्वर पर अपलोड, स्टोर या प्रोसेस नहीं करते।',
    techTitle: 'आधुनिक तकनीक',
    techText: 'WebAssembly, Canvas API और आधुनिक React सहित अत्याधुनिक वेब तकनीकों से बनाया गया।',
    communityTitle: 'समुदाय संचालित',
    communityText: 'हर फीचर जो हम बनाते हैं वास्तविक उपयोगकर्ता फीडबैक से प्रेरित है।',
    globalTitle: 'वैश्विक पहुंच',
    globalText: '120 से अधिक देशों में क्रिएटर्स द्वारा उपयोग किया जाता है।',
  },
  seo: {
    homeTitle: 'photremium.com — मुफ्त ऑनलाइन इमेज कनवर्टर, कंप्रेसर और एडिटर',
    homeDesc: 'इमेज को मुफ्त ऑनलाइन कनवर्ट, कंप्रेस, रीसाइज़, क्रॉप और एडिट करें।',
    homeKeywords: 'इमेज कनवर्टर, इमेज कंप्रेसर, इमेज रीसाइज़, फोटो एडिटर',
    aboutTitle: 'photremium.com के बारे में — हमारा मिशन और कहानी',
    aboutDesc: 'photremium.com के बारे में जानें, लाखों लोगों द्वारा विश्वसनीय मुफ्त ऑनलाइन इमेज टूलकिट।',
    aboutKeywords: 'photremium.com के बारे में, इमेज टूल्स, मुफ्त इमेज एडिटर',
  },

  privacyPolicyPage: {
    seo: {
      title: 'गोपनीयता नीति — Photremium | सर्वर अपलोड नहीं, डेटा स्टोरेज शून्य',
      description: 'Photremium की गोपनीयता नीति बताती है कि हम आपकी गोपनीयता कैसे सुरक्षित रखते हैं। सारी प्रोसेसिंग आपके ब्राउज़र में होती है।',
      ogTitle: 'गोपनीयता नीति — Photremium | बिना अपलोड, बिना स्टोरेज',
      ogDescription: 'आपकी फाइलें आपके डिवाइस में रहती हैं। प्रोसेसिंग पूरी तरह ब्राउज़र में लोकली होती है।',
      twitterTitle: 'गोपनीयता नीति — Photremium',
      twitterDescription: '100% ब्राउज़र आधारित टूल्स। न अपलोड, न स्टोरेज, न ट्रैकिंग।',
      schemaName: 'गोपनीयता नीति - Photremium',
      schemaDescription: 'Photremium गोपनीयता नीति: न सर्वर अपलोड, न डेटा स्टोरेज।',
    },
    hero: {
      badge: 'गोपनीयता नीति',
      titlePrefix: 'आपकी गोपनीयता हमारी',
      titleHighlight: 'शीर्ष प्राथमिकता',
      subPrefix: 'photremium.com एक सरल सिद्धांत पर बनाया गया है —',
      subStrong: 'आपकी फाइलें कभी भी आपके डिवाइस से बाहर नहीं जातीं',
      subSuffix: 'सभी इमेज टूल्स आपके ब्राउज़र में चलते हैं। न अपलोड। न क्लाउड। न समझौता।',
      effectiveLabel: 'प्रभावी तिथि',
      lastUpdatedLabel: 'अंतिम अपडेट',
      worldwideLabel: 'दुनिया भर में लागू',
    },
    trustCards: [
      { title: 'कोई सर्वर अपलोड नहीं', desc: 'आपकी फाइलें डिवाइस से बाहर नहीं जातीं। पूरी प्रोसेसिंग लोकल है।' },
      { title: 'डेटा स्टोरेज शून्य', desc: 'हम आपके बारे में, आपकी इमेज या गतिविधि के बारे में कुछ स्टोर नहीं करते।' },
      { title: 'कोई ट्रैकिंग नहीं', desc: 'न व्यवहार ट्रैकिंग, न फिंगरप्रिंटिंग, न प्रोफाइलिंग।' },
      { title: 'GDPR अनुकूल', desc: 'वैश्विक गोपनीयता नियमों का सम्मान करने के लिए डिज़ाइन किया गया।' },
    ],
    contentsTitle: 'विषय सूची',
    toc: {
      overview: 'ओवरव्यू',
      'no-upload': 'सर्वर प्रोसेसिंग नहीं',
      'data-collect': 'हम कौन सा डेटा लेते हैं',
      cookies: 'कुकीज़ और स्टोरेज',
      'third-party': 'थर्ड-पार्टी सेवाएँ',
      analytics: 'एनालिटिक्स',
      children: 'बच्चों की गोपनीयता',
      rights: 'आपके अधिकार',
      security: 'सुरक्षा',
      changes: 'नीति में बदलाव',
      contact: 'संपर्क करें',
    },
    sections: {
      overview: {
        title: '1. ओवरव्यू',
        subtitle: 'यह नीति क्या कवर करती है',
        p1Prefix: 'यह गोपनीयता नीति बताती है कि',
        p1Middle: '("हम", "हमारा") आपकी व्यक्तिगत जानकारी को कैसे संभालता है - या अधिक सही कहें तो,',
        p1Italic: 'संबंधित ही नहीं होता',
        p1Suffix: 'जब आप हमारे मुफ्त ऑनलाइन इमेज टूल्स का उपयोग करते हैं',
        p2: 'पारंपरिक वेब ऐप्स के विपरीत जो प्रोसेसिंग के लिए फाइलें रिमोट सर्वर पर भेजते हैं, photremium.com आधुनिक ब्राउज़र APIs (Canvas API, WebAssembly, WebWorkers) का उपयोग करता है ताकि हर ऑपरेशन आपके डिवाइस पर लोकली हो। परिणाम: न डेटा ट्रांसमिशन, न स्टोरेज, न जोखिम।',
        calloutLabel: 'सरल सारांश:',
        calloutText: 'हम आपकी इमेज देख नहीं सकते, देखना नहीं चाहते, और हमारी तकनीक इसी तरह डिज़ाइन की गई है कि हम कभी देख ही न सकें।',
      },
      noUpload: {
        title: '2. कोई सर्वर प्रोसेसिंग नहीं — कभी नहीं',
        subtitle: 'हमारे टूल वास्तव में कैसे काम करते हैं',
        introPrefix: 'photremium.com का हर टूल — इमेज कनवर्टर, कंप्रेसर, रीसाइज़र, बैकग्राउंड रिमूवर, फेस ब्लर, वॉटरमार्क, क्रॉप और QR टूल्स — आपकी फाइलों को',
        introStrong: '100% आपके वेब ब्राउज़र के अंदर',
        introSuffix: 'क्लाइंट-साइड JavaScript और WebAssembly से प्रोसेस करता है।',
        points: [
          { label: 'कोई फाइल अपलोड नहीं होती।', text: 'फाइल चुनने पर यह आपके ब्राउज़र की File API से मेमोरी में प्रोसेस होती है, नेटवर्क पर नहीं भेजी जाती।' },
          { label: 'कोई सर्वर आपकी इमेज नहीं पाता।', text: 'हमारा CDN केवल HTML, CSS और JavaScript देता है; आपकी फाइलें नहीं।' },
          { label: 'कोई अस्थायी स्टोरेज नहीं।', text: 'परिणाम केवल ब्राउज़र मेमोरी में रहते हैं और पेज छोड़ने पर हट जाते हैं।' },
          { label: 'ऑफ़लाइन भी काम करता है।', text: 'पहली लोडिंग के बाद अधिकतर टूल बिना इंटरनेट भी चल जाते हैं।' },
        ],
        callout: 'आप स्वयं जांच सकते हैं: DevTools में Network टैब खोलें, इमेज चुनें, और पुष्टि करें कि कोई फाइल डेटा बाहरी सर्वर को नहीं भेजा गया।',
      },
      dataCollect: {
        title: '3. हम कौन सा डेटा लेते हैं (और नहीं लेते)',
        subtitle: 'डेटा प्रथाओं पर पूर्ण पारदर्शिता',
        headers: { type: 'डेटा प्रकार', collected: 'संग्रहित?', whereWhy: 'कहाँ / क्यों' },
        rows: [
          { type: 'आपकी इमेज / फाइलें', badge: 'कभी नहीं', variant: 'green', showX: true, whereWhy: 'पूरी तरह ब्राउज़र में प्रोसेस, कभी ट्रांसमिट नहीं' },
          { type: 'नाम / ईमेल पता', badge: 'कभी नहीं', variant: 'green', showX: true, whereWhy: 'किसी टूल के लिए अकाउंट/साइन-अप आवश्यक नहीं' },
          { type: 'IP पता', badge: 'न्यूनतम', variant: 'gray', showX: false, whereWhy: 'मानक वेब लॉग <= 30 दिन, पहचान से जुड़ा नहीं' },
          { type: 'ब्राउज़र / OS प्रकार', badge: 'न्यूनतम', variant: 'gray', showX: false, whereWhy: 'ब्राउज़र स्वतः भेजता है; केवल संगतता हेतु' },
          { type: 'देखे गए पेज / क्लिक', badge: 'समेकित', variant: 'blue', showX: false, whereWhy: 'केवल अनाम एनालिटिक्स (कोई व्यक्तिगत पहचान नहीं)' },
          { type: 'भाषा वरीयता', badge: 'सिर्फ लोकल', variant: 'blue', showX: false, whereWhy: 'आपके डिवाइस के localStorage में सेव; हमें नहीं भेजा जाता' },
          { type: 'भुगतान / वित्तीय डेटा', badge: 'कभी नहीं', variant: 'green', showX: true, whereWhy: 'photremium.com पूरी तरह मुफ्त है, भुगतान आवश्यक नहीं' },
        ],
      },
      cookies: {
        title: '4. कुकीज़ और लोकल स्टोरेज',
        subtitle: 'आपके डिवाइस में क्या सहेजा जाता है',
        intro: 'photremium.com विज्ञापन कुकीज़, क्रॉस-साइट ट्रैकिंग कुकीज़ और थर्ड-पार्टी कुकीज़ का उपयोग नहीं करता। केवल आवश्यक साइट कार्यक्षमता के लिए ब्राउज़र स्टोरेज उपयोग होता है।',
        points: [
          { label: 'भाषा वरीयता', text: 'localStorage में सेव होती है ताकि साइट अगली बार भी आपकी भाषा याद रखे।' },
          { label: 'थीम / UI वरीयताएँ', text: 'यदि आप डिस्प्ले पसंद चुनते हैं, यह केवल आपके डिवाइस में सेव होती है।' },
          { label: 'कोई सेशन कुकी नहीं।', text: 'photremium.com में लॉगिन सिस्टम नहीं है, इसलिए सेशन ID कुकीज़ नहीं लिखी जातीं।' },
        ],
        callout: 'आप किसी भी समय ब्राउज़र सेटिंग से photremium.com का लोकल स्टोरेज साफ कर सकते हैं (Settings -> Privacy -> Clear browsing data -> Cached data & cookies)। इससे टूल उपयोग पर कोई असर नहीं पड़ेगा।',
      },
      thirdParty: {
        title: '5. थर्ड-पार्टी सेवाएँ',
        subtitle: 'हम कौन सी बाहरी सेवाएँ उपयोग करते हैं और क्यों',
        intro: 'photremium.com केवल इंफ्रास्ट्रक्चर और प्रदर्शन के लिए सीमित और भरोसेमंद थर्ड-पार्टी सेवाएँ उपयोग करता है। इनमें से कोई भी आपकी इमेज या व्यक्तिगत पहचान योग्य जानकारी प्राप्त नहीं करती।',
        headers: { service: 'सेवा', purpose: 'उद्देश्य', dataShared: 'साझा डेटा', privacyPolicy: 'गोपनीयता नीति' },
        rows: [
          { service: 'Cloudflare Pages', purpose: 'साइट एसेट होस्टिंग और CDN डिलीवरी', dataShared: 'IP पता, HTTP हेडर्स (मानक)', privacyLink: 'https://www.cloudflare.com/privacypolicy/', privacyText: 'cloudflare.com/privacypolicy' },
          { service: 'Font Awesome', purpose: 'CDN से आइकन फ़ॉन्ट लोडिंग', dataShared: 'IP पता (केवल CSS अनुरोध)', privacyLink: 'https://fontawesome.com/privacy', privacyText: 'fontawesome.com/privacy' },
          { service: 'Google Fonts', purpose: 'टाइपफेस लोडिंग (यदि लागू हो)', dataShared: 'IP पता (केवल फ़ॉन्ट अनुरोध)', privacyLink: 'https://policies.google.com/privacy', privacyText: 'policies.google.com' },
        ],
        outro: 'हम आपका डेटा विज्ञापनदाताओं, डेटा ब्रोकरों या सूचीबद्ध इंफ्रास्ट्रक्चर प्रदाताओं के अलावा किसी तीसरे पक्ष के साथ साझा नहीं करते।',
      },
      analytics: {
        title: '6. एनालिटिक्स',
        subtitle: 'गोपनीयता-सम्मानित समेकित उपयोग डेटा',
        introPrefix: 'यह समझने के लिए कि कौन से टूल अधिक उपयोगी हैं और साइट कैसे बेहतर की जाए, हम',
        introStrong: 'समेकित और अनाम',
        introSuffix: 'उपयोग आँकड़े ले सकते हैं, जैसे:',
        points: [
          'प्रति टूल पेज व्यू की संख्या (उपयोगकर्ता पहचान के बिना)',
          'रेफरल स्रोत (जैसे Google खोज, डायरेक्ट लिंक) — बिना व्यक्तिगत डेटा',
          'देश-स्तर का भौगोलिक डेटा (शहर या सटीक स्थान नहीं)',
          'संगतता विश्लेषण हेतु ब्राउज़र / डिवाइस प्रकार',
        ],
        calloutLabel: 'कोई डेटा व्यक्तिगत रूप से आपसे लिंक नहीं होता।',
        calloutText: 'हम Google Analytics या Meta Pixel का उपयोग नहीं करते। यदि एनालिटिक्स उपयोग करते हैं तो privacy-first टूल्स (जैसे Plausible) ही होते हैं।',
      },
      children: {
        title: '7. बच्चों की गोपनीयता',
        subtitle: 'बाल सुरक्षा अनुपालन',
        p1: 'photremium.com जानबूझकर 13 वर्ष से कम (या EU में GDPR के तहत 16 वर्ष से कम) बच्चों से व्यक्तिगत जानकारी एकत्र नहीं करता। चूंकि हम किसी भी उपयोगकर्ता का व्यक्तिगत डेटा एकत्र नहीं करते, यह साइट सभी के लिए समान रूप से सुरक्षित है।',
        p2Prefix: 'यदि आपको लगता है कि किसी बच्चे ने हमारे संपर्क फ़ॉर्म से व्यक्तिगत जानकारी भेजी है, तो तुरंत इस ईमेल पर संपर्क करें',
        p2Suffix: 'और हम उसे तुरंत हटा देंगे।',
      },
      rights: {
        title: '8. आपके अधिकार',
        subtitle: 'वैश्विक गोपनीयता अधिकार',
        intro: 'क्योंकि photremium.com व्यक्तिगत पहचान योग्य जानकारी एकत्र नहीं करता, अधिकांश डेटा अधिकार सरल रूप से लागू होते हैं — आपके बारे में एक्सेस, सुधार या हटाने के लिए डेटा मौजूद ही नहीं। फिर भी हम इन अधिकारों का सम्मान करते हैं:',
        points: [
          { label: 'एक्सेस का अधिकार', text: 'आप हमारे पास मौजूद अपने डेटा की प्रति मांग सकते हैं। (अनाम लॉग्स के अलावा कुछ नहीं।)' },
          { label: 'सुधार का अधिकार', text: 'आप गलत व्यक्तिगत डेटा के सुधार का अनुरोध कर सकते हैं।' },
          { label: 'मिटाने का अधिकार (Right to be forgotten)', text: 'आप व्यक्तिगत डेटा मिटाने का अनुरोध कर सकते हैं (GDPR Art. 17, CCPA)।' },
          { label: 'आपत्ति / opt-out का अधिकार', text: 'आप ब्राउज़र स्तर के opt-out या ad-block टूल से भविष्य की एनालिटिक्स से बाहर निकल सकते हैं।' },
          { label: 'डेटा पोर्टेबिलिटी का अधिकार', text: 'आपका सारा काम सीधे आपके डिवाइस में डाउनलोड होता है — अलग एक्सपोर्ट अनुरोध की जरूरत नहीं।' },
        ],
        callout: 'ये अधिकार सभी उपयोगकर्ताओं पर लागू होते हैं — हम सर्वोच्च मानक (GDPR) को आधार मानते हैं।',
      },
      security: {
        title: '9. सुरक्षा',
        subtitle: 'हम आपके अनुभव की सुरक्षा कैसे करते हैं',
        intro: 'सबसे सुरक्षित डेटा वही है जो एकत्र ही न किया जाए। photremium.com की client-side संरचना के कारण सर्वर breach भी आपकी फाइलें उजागर नहीं कर सकता क्योंकि वे सर्वर पर होती ही नहीं। अतिरिक्त उपाय:',
        points: [
          { label: 'HTTPS लागू', text: 'आपके ब्राउज़र और हमारे CDN के बीच सारा ट्रैफिक TLS 1.2+ और HSTS से एन्क्रिप्टेड है।' },
          { label: 'Content Security Policy (CSP)', text: 'कड़े हेडर XSS और inline script injection से बचाते हैं।' },
          { label: 'नियमित dependency audits', text: 'ज्ञात कमजोरियों को पैच करने के लिए हम npm पैकेज नियमित रूप से ऑडिट और अपडेट करते हैं।' },
        ],
        disclosurePrefix: 'जिम्मेदार खुलासा',
        disclosureTextPrefix: 'यदि आपको सुरक्षा समस्या मिले तो हमें ईमेल करें',
        disclosureTextSuffix: 'और हम 48 घंटे में जवाब देंगे।',
      },
      changes: {
        title: '10. इस नीति में बदलाव',
        subtitle: 'हम अपडेट्स को कैसे संभालते हैं',
        intro: 'हम समय-समय पर अपनी प्रथाओं, टूल्स या कानूनी आवश्यकताओं के आधार पर इस गोपनीयता नीति को अपडेट कर सकते हैं। जब ऐसा होगा:',
        points: [
          { label: '"अंतिम अपडेट"', text: 'तिथि इस पेज के शीर्ष पर संशोधित की जाएगी।' },
          { label: 'महत्वपूर्ण बदलाव', text: 'होम पेज पर कम से कम 30 दिनों तक प्रमुख सूचना के साथ बताए जाएंगे।' },
          { label: 'पिछले संस्करण', text: 'आर्काइव किए जाएंगे और अनुरोध पर उपलब्ध होंगे।' },
        ],
        outro: 'बदलाव प्रकाशित होने के बाद photremium.com का उपयोग अपडेटेड नीति की स्वीकृति माना जाएगा। कृपया इस पेज को समय-समय पर देखें।',
      },
      contact: {
        title: '11. संपर्क और डेटा अनुरोध',
        subtitle: 'गोपनीयता से जुड़े प्रश्नों के लिए संपर्क करें',
        p1Prefix: 'इस गोपनीयता नीति से संबंधित किसी भी प्रश्न, चिंता या औपचारिक डेटा अनुरोध के लिए हमसे संपर्क करें। हमारा लक्ष्य है कि हम जवाब दें',
        p1Strong: '5 कार्यदिवस',
      },
    },
    footer: {
      privacyQuestionsTitle: 'गोपनीयता से जुड़े प्रश्न?',
      privacyQuestionsDesc: 'अपने प्रश्न या डेटा अनुरोध भेजें, हम शीघ्र जवाब देंगे।',
      versionHistoryTitle: 'संस्करण इतिहास',
      v2Label: 'v2.0 — प्रमुख पुनर्लेखन',
      v11Label: 'v1.1 — CCPA अधिकार जोड़े गए',
      v10Label: 'v1.0 — प्रारंभिक नीति',
    },
  },

  common: {
    new: 'नया!',
    download: 'डाउनलोड',
    downloadAll: 'सभी डाउनलोड करें',
    upload: 'अपलोड',
    dragDrop: 'इमेज यहां ड्रैग एंड ड्रॉप करें, या ब्राउज़ करने के लिए क्लिक करें',
    remove: 'हटाएं',
    reset: 'रीसेट',
    apply: 'लागू करें',
    cancel: 'रद्द करें',
    clear: 'साफ करें',
    close: 'बंद करें',
    save: 'सेव करें',
    processing: 'प्रोसेसिंग...',
    noFiles: 'कोई फाइल चयनित नहीं',
    selectFiles: 'फाइलें चुनें',
    or: 'या',
    browseFiles: 'फाइलें ब्राउज़ करें',
    dropHere: 'फाइलें यहां छोड़ें',
    quality: 'क्वालिटी',
    width: 'चौड़ाई',
    height: 'ऊंचाई',
    format: 'फॉर्मेट',
    compression: 'कंप्रेशन',
    preview: 'प्रीव्यू',
    original: 'मूल',
    result: 'परिणाम',
    before: 'पहले',
    after: 'बाद',
    downloadAs: 'के रूप में डाउनलोड करें:',
    zip: 'ZIP',
    separate: 'अलग',
    chooseFiles: 'फाइलें चुनें',
    pasteHint: 'आप इमेज भी पेस्ट कर सकते हैं',
    startOver: 'फिर से शुरू करें',
    startOverConfirm: 'सभी इमेज हटाएं और फिर से शुरू करें?',
    addMoreImages: 'और इमेज जोड़ें',
    addImage: 'इमेज जोड़ें',
    images: 'इमेज',
    totalSize: 'कुल आकार',
    size: 'आकार',
    type: 'प्रकार',
    unsavedEdits: 'आपके पास सहेजे नहीं गए बदलाव हैं। पेज छोड़ें?',
    compareSlider: 'तुलना स्लाइडर',
    toggleToolsPanel: 'टूल पैनल टॉगल करें',
    closePanel: 'पैनल बंद करें',
    zoomIn: 'ज़ूम इन',
    zoomOut: 'ज़ूम आउट',
    fit: 'फिट करें',
    none: 'कोई नहीं',
  },

  compressor: {
    seo: {
      uploadTitle: 'इमेज कंप्रेसर — JPG, PNG, SVG, GIF मुफ्त में कंप्रेस करें | photremium.com',
      uploadDesc: 'JPG, PNG, SVG और GIF इमेज ऑनलाइन मुफ्त में कंप्रेस करें। फाइलें 80% तक छोटी।',
      uploadKeywords: 'इमेज कंप्रेसर, jpg कंप्रेस, png कंप्रेस, इमेज साइज कम करें',
      workspaceTitle: 'इमेज कंप्रेस करें — photremium.com इमेज कंप्रेसर',
      workspaceDesc: 'कंप्रेशन स्तर समायोजित करें और अनुकूलित इमेज डाउनलोड करें।',
      workspaceKeywords: 'इमेज कंप्रेस करें, इमेज कंप्रेशन',
    },
    title: 'इमेज कंप्रेसर',
    desc: 'JPG, PNG और GIF इमेज 80% तक छोटी करें। तेज़ और निजी।',
    toCompress: 'कंप्रेस करने के लिए',
    compressionForAll: 'सभी इमेज के लिए कंप्रेशन',
    summary: 'सारांश',
    originalSize: 'मूल आकार',
    compressed: 'कंप्रेस्ड',
    saved: 'बचाया',
    compressionLabel: 'कंप्रेशन:',
    compressing: 'कंप्रेस हो रहा है…',
    compressDownload: 'कंप्रेस करें और डाउनलोड करें',
    lowQualityWarning: 'उच्च कंप्रेशन से छवि की स्पष्टता काफी कम हो सकती है।',
    blog: {
      tocTitle: 'विषय सूची',
      title: 'इमेज कंप्रेसर ब्लॉग',
      formatsIntro: 'हमारा टूल सभी इमेज फ़ॉर्मैट्स को सपोर्ट करता है। इसलिए आप किसी भी इमेज को आसानी से कंप्रेस कर सकते हैं। सभी फ़ॉर्मैट्स की सूची नीचे दी गई है:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. इमेज कंप्रेसर क्या है?',
          paragraphs: [
            'इमेज कंप्रेसर एक टूल या ऑनलाइन सेवा है जो इमेज की फाइल साइज़ को उसकी विज़ुअल क्वालिटी बनाए रखते हुए कम करता है। लेकिन बहुत अधिक कंप्रेशन करने पर क्वालिटी में दिखने वाली कमी आ सकती है।',
          ],
          listTitle: 'प्रकार:',
          bullets: [
            'लॉसी कंप्रेशन: इस प्रकार में कुछ इमेज डेटा हटाकर फाइल साइज़ कम की जाती है। क्वालिटी थोड़ी घट सकती है, लेकिन अक्सर यह अंतर सामान्य आँखों से कम दिखाई देता है।',
            'लॉसलेस कंप्रेशन: इसमें इमेज की विज़ुअल क्वालिटी को प्रभावित किए बिना फाइल साइज़ कम की जाती है।',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. हमारा टूल क्यों चुनें?',
          bullets: [
            'हमारा AI आधारित इमेज कंप्रेसर सभी डिवाइस पर सहजता से काम करता है और बेहतरीन परिणाम देता है।',
            'आप एक ही क्लिक में कई इमेज (यहाँ तक कि 100+) कंप्रेस कर सकते हैं।',
            'इमेज को हमारे सर्वर पर अपलोड करने की जरूरत नहीं है। सब कुछ आपके लोकल ब्राउज़र में प्रोसेस होता है।',
            'हमारा इमेज कंप्रेसर हमेशा के लिए पूरी तरह मुफ्त है। आप इसे अपने दोस्तों के साथ भी शेयर कर सकते हैं।',
            'आप अपनी पसंद के अनुसार कंप्रेशन प्रतिशत चुन सकते हैं।',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. स्टेप बाय स्टेप गाइड',
          steps: [
            {
              heading: '1. जिन इमेज को कंप्रेस करना है उन्हें चुनें।',
              bullets: [
                'इमेज को ड्रैग-एंड-ड्रॉप करके अपलोड बॉक्स में डालें।',
                'आप (Ctrl + V) से इमेज कॉपी-पेस्ट भी कर सकते हैं।',
                'चूज़ बटन पर क्लिक करके फाइल एक्सप्लोरर से भी इमेज चुन सकते हैं।',
              ],
            },
            {
              heading: '2. फिर कंप्रेशन प्रतिशत चुनें।',
              bullets: [
                'हॉरिज़ॉन्टल स्लाइड बार से कंप्रेशन प्रतिशत चुनना आसान है। सही परिणाम के लिए नीचे दिए गए रेंज का पालन करें।',
              ],
              table: {
                headers: ['कंप्रेशन प्रतिशत', 'परिणाम'],
                rows: [
                  ['1%  से  40%', 'बेहतरीन क्वालिटी'],
                  ['41%  से  60%', 'सामान्य क्वालिटी (अनुशंसित)'],
                  ['61%  से  100%', 'खराब क्वालिटी'],
                ],
              },
            },
            {
              heading: '3. बचाई गई मेमोरी देखें।',
              paragraphs: [
                'सभी मेमोरी मेट्रिक्स रियल-टाइम में दिखाई जाती हैं। आप स्पष्ट रूप से देख सकते हैं कि कुल में से कितनी मेमोरी बची और उसी के अनुसार कंप्रेशन लेवल समायोजित कर सकते हैं।',
              ],
            },
            {
              heading: '4. टॉगल बटन से डाउनलोड विकल्प चुनें।',
              bullets: [
                'ZIP: अगर आप कई इमेज कंप्रेस कर रहे हैं तो यह विकल्प दिखेगा। ZIP चुनने पर सभी कंप्रेस्ड इमेज एक zip फाइल में मिलेंगी (बहुत सारी इमेज के लिए अनुशंसित)।',
                'Separate: इस विकल्प में सभी इमेज अलग-अलग डाउनलोड होंगी, एक ZIP में नहीं (कम इमेज, 10 से कम, के लिए अनुशंसित)।',
              ],
            },
            {
              heading: '5. इमेज कंप्रेस करें और डाउनलोड करें।',
              paragraphs: [
                'यह बटन आपकी चुनी हुई डाउनलोड सेटिंग के अनुसार सभी कंप्रेस्ड इमेज अपने-आप डाउनलोड कर देगा।',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. इमेज कंप्रेसर के फायदे।',
          bullets: [
            'स्टोरेज लागत कम होती है: इमेज कंप्रेस करने से उनका आकार घटता है और स्टोरेज की जरूरत कम पड़ती है।',
            'तेज़ लोडिंग: कंप्रेस्ड इमेज जल्दी लोड होती हैं, जिससे वेबसाइट या ऐप का यूज़र अनुभव बेहतर होता है।',
            'Gmail सीमा का समाधान: Gmail में 25MB तक अटैचमेंट सीमा होने के कारण कंप्रेशन उपयोगी है और अधिक फाइलें भेजी जा सकती हैं।',
            'तेज़ शेयरिंग और ट्रांसफर: बड़ी फाइलें भेजने में ज़्यादा समय लगता है; कंप्रेशन समय और डेटा बचाता है।',
            'प्रेज़ेंटेशन ऑप्टिमाइज़ेशन: बिना कंप्रेस इमेज वाली प्रेज़ेंटेशन भारी हो सकती है, जबकि कंप्रेस्ड इमेज से फाइल साइज़ काफी कम रहता है।',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. समर्थित फ़ॉर्मैट।',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'इमेज कन्वर्टर — PNG, JPG, WEBP, GIF, SVG मुफ्त में बदलें | photremium.com',
      uploadDesc: 'JPG, PNG, WEBP, GIF, SVG, TIFF, BMP के बीच इमेज बदलें। मुफ्त और निजी।',
      uploadKeywords: 'इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',
      workspaceKeywords: 'इमेज बदलें, इमेज फॉर्मेट कन्वर्टर',

      routeKeywords: {

        'png-to-jpg': 'png बदलने के लिए jpg, png to jpg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'jpg-to-png': 'jpg बदलने के लिए png, jpg to png, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'png-to-webp': 'png बदलने के लिए webp, png to webp, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'jpg-to-webp': 'jpg बदलने के लिए webp, jpg to webp, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'webp-to-jpg': 'webp बदलने के लिए jpg, webp to jpg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'webp-to-png': 'webp बदलने के लिए png, webp to png, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'gif-to-jpg': 'gif बदलने के लिए jpg, gif to jpg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'gif-to-png': 'gif बदलने के लिए png, gif to png, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'bmp-to-jpg': 'bmp बदलने के लिए jpg, bmp to jpg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'bmp-to-png': 'bmp बदलने के लिए png, bmp to png, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'svg-to-png': 'svg बदलने के लिए png, svg to png, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'svg-to-jpg': 'svg बदलने के लिए jpg, svg to jpg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'tiff-to-jpg': 'tiff बदलने के लिए jpg, tiff to jpg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'tiff-to-png': 'tiff बदलने के लिए png, tiff to png, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'jpg-to-gif': 'jpg बदलने के लिए gif, jpg to gif, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'png-to-gif': 'png बदलने के लिए gif, png to gif, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'jpg-to-bmp': 'jpg बदलने के लिए bmp, jpg to bmp, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'png-to-bmp': 'png बदलने के लिए bmp, png to bmp, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'webp-to-gif': 'webp बदलने के लिए gif, webp to gif, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'jpg-to-ico': 'jpg बदलने के लिए ico, jpg to ico, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'png-to-ico': 'png बदलने के लिए ico, png to ico, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'jpg-to-svg': 'jpg बदलने के लिए svg, jpg to svg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'png-to-svg': 'png बदलने के लिए svg, png to svg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'webp-to-svg': 'webp बदलने के लिए svg, webp to svg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'gif-to-svg': 'gif बदलने के लिए svg, gif to svg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'bmp-to-svg': 'bmp बदलने के लिए svg, bmp to svg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

        'tiff-to-svg': 'tiff बदलने के लिए svg, tiff to svg, इमेज कन्वर्टर, png से jpg, jpg से png, webp कन्वर्टर',

      },
    },
    title: 'इमेज कन्वर्टर',
    desc: 'JPG, PNG, WEBP, GIF, SVG, TIFF, BMP और अधिक के बीच इमेज बदलें।',
    toConvert: 'बदलने के लिए',
    convertSettings: 'रूपांतरण सेटिंग्स',
    detected: 'पहचाना',
    convertTo: 'में बदलें',
    converting: 'बदल रहे हैं…',
    convertToFormat: '{format} में बदलें',
    popularConversions: 'लोकप्रिय रूपांतरण',
    convertingTo: 'में बदल रहे हैं',
    all: 'सभी',
  },

  resizer: {
    seo: {
      uploadTitle: 'इमेज रिसाइज़ — JPG, PNG मुफ्त में स्केल करें | photremium.com',
      uploadDesc: 'इमेज को ऑनलाइन मुफ्त में पिक्सेल या प्रतिशत से रिसाइज़ करें।',
      uploadKeywords: 'इमेज रिसाइज़, इमेज साइज़ बदलें',
      workspaceTitle: 'इमेज रिसाइज़ करें — photremium.com',
      workspaceDesc: 'इमेज साइज़ ऑनलाइन मुफ्त में बदलें।',
      workspaceKeywords: 'इमेज रिसाइज़',
    },
    title: 'इमेज रिसाइज़ करें',
    desc: 'पिक्सेल, प्रतिशत, सेंटीमीटर या इंच में आयाम सेट करें और तुरंत रिसाइज़ करें।',
    toResize: 'रिसाइज़ करने के लिए',
    resizeSettings: 'रिसाइज़ सेटिंग्स',
    resizeBy: 'इसके अनुसार रिसाइज़ करें:',
    byPixels: 'पिक्सेल से',
    byPercentage: 'प्रतिशत से',
    byCentimeters: 'सेंटीमीटर से',
    byInches: 'इंच से',
    advanced: 'उन्नत',
    lockAspect: 'अनुपात लॉक करें',
    unlockAspect: 'अनुपात अनलॉक करें',
    dontEnlarge: 'यदि मूल छोटा हो तो बड़ा न करें',
    resizing: 'रिसाइज़ हो रहा है…',
    resizeDownload: 'रिसाइज़ करें और डाउनलोड करें',
    blog: {
      tocTitle: 'सामग्री',
      title: 'इमेज रिसाइज़र ब्लॉग',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. इमेज रिसाइज़र का उपयोग क्यों करें?',
          paragraphs: [
            'इमेज रिसाइज़र एक टूल या सॉफ़्टवेयर है जिसका उपयोग इमेज के आयाम बदलने के लिए किया जाता है। यह आपको इमेज की ऊँचाई, चौड़ाई या दोनों बदलकर उसका आकार समायोजित करने देता है। यह टूल सोशल मीडिया प्लेटफ़ॉर्म्स के लिए खास तौर पर उपयोगी है, जहाँ इमेज अपलोड/पोस्ट के लिए आकार की सीमाएँ होती हैं।',
          ],
          listTitle: 'उदाहरण के लिए:',
          bullets: [
            'Instagram पोस्ट: 1080 x 1080px (Square)',
            'Facebook पोस्ट: 1200 x 630px',
            'X (पूर्व Twitter) पोस्ट: 1200 x 675px',
            'Instagram Story: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. हमारा इमेज रिसाइज़र टूल क्यों चुनें?',
          paragraphs: [
            'हमारा AI-संचालित इमेज रिसाइज़र इमेज रिसाइज़िंग प्रक्रिया को सटीक और बेहद तेज़ बनाता है। आप इस टूल को हर डिवाइस पर आसानी से उपयोग कर सकते हैं। किसी ऐप को इंस्टॉल या डाउनलोड करने की आवश्यकता नहीं है। सभी सेवाएँ आपके पसंदीदा ब्राउज़र में ऑनलाइन उपलब्ध हैं।',
          ],
          bullets: [
            'आप हमारे टूल से एक साथ कई इमेज (यहाँ तक कि 100+) रिसाइज़ कर सकते हैं। यदि आपके पास हाई-परफॉर्मेंस डिवाइस है, तो आप सेकंडों में 400 से 500 इमेज तक रिसाइज़ कर सकते हैं।',
            'सारी प्रोसेसिंग आपके लोकल ब्राउज़र में होती है। आपको इमेज हमारे सर्वर पर अपलोड नहीं करनी पड़ती। आपकी इमेज कभी आपके डिवाइस से बाहर नहीं जातीं, इसलिए आपकी प्राइवेसी सुरक्षित रहती है।',
            'रिसाइज़िंग के लिए कई यूनिट्स सपोर्ट होती हैं।',
            'रिसाइज़ करने के बाद भी आप केवल चेकबॉक्स चुनकर इमेज का मूल aspect ratio बनाए रख सकते हैं।',
            'यदि आप कई इमेज रिसाइज़ कर रहे हैं, तो आप आउटपुट को अलग-अलग इमेज या ZIP फ़ाइल के रूप में डाउनलोड कर सकते हैं।',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. चरण-दर-चरण गाइड',
          steps: [
            {
              heading: 'सबसे पहले, वह इमेज या कई इमेज चुनें जिन्हें आप रिसाइज़ करना चाहते हैं। इमेज चुनने के कई तरीके हैं।',
              bullets: [
                'इमेज को ड्रैग और ड्रॉप करके सीधे रिसाइज़ करें।',
                'ड्रॉप बॉक्स में इमेज पेस्ट करने के लिए “Ctrl + V” शॉर्टकट भी सपोर्टेड है।',
                '“Choose Files” बटन पर क्लिक करने से फाइल एक्सप्लोरर खुलेगा। वहाँ से भी आप अपनी इच्छित इमेज चुन सकते हैं।',
              ],
            },
            {
              heading: 'फिर, इमेज रिसाइज़ करने के लिए एक यूनिट चुनें। वर्तमान में उपलब्ध यूनिट्स:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'यूनिट चुनने के बाद, इमेज रिसाइज़ करने के लिए ऊँचाई और चौड़ाई समायोजित करें। आप चेकबॉक्स टिक करके aspect ratio भी लॉक कर सकते हैं।',
            },
            {
              heading: 'फिर “Don’t enlarge if original is smaller” चेकबॉक्स टिक करें, यदि आप नहीं चाहते कि इमेज अपने मूल आकार से बड़ी हो।',
            },
            {
              heading: 'इसके बाद डाउनलोड विकल्प चुनें।',
              bullets: [
                'यदि आप कई इमेज रिसाइज़ कर रहे हैं और सभी को एक zip फ़ाइल में डाउनलोड करना चाहते हैं, तो ZIP चुनें।',
                'या हर इमेज अलग-अलग डाउनलोड करने के लिए “separate” चुनें।',
              ],
            },
            {
              heading: 'फिर “Resize & Download” बटन दबाएँ, ताकि आपकी चुनी हुई डाउनलोड सेटिंग के अनुसार रिसाइज़ की गई इमेज डाउनलोड हो जाएँ।',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. इमेज रिसाइज़िंग टूल के लाभ: इस टूल का सबसे महत्वपूर्ण लाभ है वेबपेज और सोशल मीडिया पोस्ट में इमेज का सही स्थान निर्धारण।',
          tocLabel: '4. इमेज रिसाइज़िंग टूल के लाभ',
          bullets: [
            'UX में सुधार: सही आकार और उचित प्लेसमेंट यूज़र अनुभव को बहुत बेहतर बनाते हैं। बिना समायोजन के बहुत बड़ी या बहुत छोटी इमेज खराब UX देती हैं।',
            'सोशल मीडिया सपोर्ट: कई सोशल मीडिया ऐप्स की अपनी इमेज डाइमेंशन सीमाएँ होती हैं। हमारा टूल आपकी इमेज को उन्हीं आवश्यक आयामों में ढालने में मदद करता है।',
            'रिस्पॉन्सिव डिज़ाइन: यदि आप डेवलपर हैं और responsive डिज़ाइन बना रहे हैं, तो अलग-अलग डिवाइस सपोर्ट के लिए इमेज को कई आयामों में रिसाइज़ करना जरूरी है।',
            'सबसे अच्छा विकल्प: इमेज को स्ट्रेच या क्रॉप करने की बजाय, जिससे आयाम बिगड़ सकते हैं, इमेज रिसाइज़र बेहतर विकल्प है।',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. समर्थित फॉर्मेट: हमारा इमेज रिसाइज़र आपको किसी भी फॉर्मेट की इमेज रिसाइज़ करने देता है। ये समर्थित फॉर्मेट हैं:',
          tocLabel: '5. समर्थित फॉर्मेट',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'इमेज क्रॉप — JPG, PNG, GIF मुफ्त में काटें | photremium.com',
      uploadDesc: 'JPG, PNG और GIF इमेज आसानी से ऑनलाइन क्रॉप करें।',
      uploadKeywords: 'इमेज क्रॉप, jpg काटना, png काटना',
      workspaceTitle: 'इमेज क्रॉप करें — photremium.com',
      workspaceDesc: 'इमेज ऑनलाइन मुफ्त में क्रॉप करें।',
      workspaceKeywords: 'इमेज क्रॉप',
    },
    title: 'इमेज क्रॉप करें',
    desc: 'विज़ुअल एडिटर के साथ JPG, PNG, GIF और अधिक इमेज क्रॉप करें।',
    toCrop: 'क्रॉप करने के लिए',
    cropSettings: 'क्रॉप सेटिंग्स',
    widthPx: 'चौड़ाई (px)',
    heightPx: 'ऊंचाई (px)',
    positionX: 'स्थिति X (px)',
    positionY: 'स्थिति Y (px)',
    cropTemplate: 'क्रॉप टेम्पलेट',
    landscape: 'लैंडस्केप',
    portrait: 'पोर्ट्रेट',
    square: 'वर्ग',
    freeform: 'मुक्त रूप',
    cropping: 'क्रॉप हो रहा है…',
    cropDownload: 'क्रॉप करें और डाउनलोड करें',
    cropDownloadAll: 'सभी क्रॉप करें और डाउनलोड करें',
    saveNext: 'सहेजें और अगला',
    croppedNofTotal: 'आपने {total} में से {n} इमेज क्रॉप किए।',
    downloadN: '{n} डाउनलोड करें',
    blog: {
      tocTitle: 'सामग्री',
      title: 'इमेज क्रॉपर ब्लॉग',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. इमेज क्रॉपर का उपयोग क्यों करें?',
          paragraphs: [
            'इमेज क्रॉपर एक सॉफ्टवेयर टूल है जिसका उपयोग इमेज को मनचाहे आकार में काटने के लिए किया जाता है। इसका व्यापक रूप से उपयोग इमेज के आवश्यक हिस्से को काटने और किसी भी उद्देश्य के लिए बाहरी अनचाहे हिस्से को हटाने में किया जाता है। यह एक क्रॉप बॉक्स प्रदान करता है जिसे आप उस स्थिति में समायोजित कर सकते हैं जहाँ आप क्रॉप करना चाहते हैं।',
          ],
          listTitle: 'उदाहरण के लिए:',
          bullets: [
            'ग्रुप फोटो में से अपनी इमेज काटना।',
            'सूची में से अपना नाम काटना।',
            'फुल स्क्रीन स्निपेट में से प्रोग्रेस बार काटना।',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. हमारा इमेज क्रॉपर क्यों चुनें?',
          paragraphs: [
            'हमारा इमेज क्रॉपर टूल आपको इमेज को सटीकता के साथ और बहुत तेज़ी से क्रॉप करने देता है। आपको बस क्रॉप बॉक्स का आकार उस स्थिति में समायोजित करना है जिसे आप किसी भी इमेज से काटना चाहते हैं। इमेज चुनने के लिए लगभग सभी इमेज फॉर्मेट समर्थित हैं।',
          ],
          bullets: [
            'आप उतनी इमेज क्रॉप कर सकते हैं जितनी आपका डिवाइस सपोर्ट करता है। यदि आपके पास बेहतर प्रदर्शन वाला डिवाइस है, तो आप बिना किसी लैग या अन्य समस्या के एक बार में 100+ इमेज भी क्रॉप कर सकते हैं।',
            'आपकी इमेज आपके लोकल ब्राउज़र पर प्रोसेस होंगी। किसी भी इमेज को हमारे सर्वर पर अपलोड करने की जरूरत नहीं है, इसलिए कोई भी इमेज आपके डिवाइस से बाहर नहीं जाती। आप अपनी व्यक्तिगत इमेज बिना किसी असुरक्षा या जोखिम के क्रॉप कर सकते हैं।',
            'कई टूल अमान्य इमेज फॉर्मेट की त्रुटि दिखाते हैं। हमारा इमेज क्रॉपर टूल लगभग सभी इमेज फॉर्मेट का समर्थन करके इस समस्या का समाधान करता है।',
            'यदि आप एक बार में कई इमेज क्रॉप कर रहे हैं, तो हमारा टूल आपकी पसंद के अनुसार क्रॉप की गई इमेज को ZIP या अलग-अलग इमेज के रूप में डाउनलोड करने की सुविधा देता है।',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. चरण दर चरण गाइड',
          steps: [
            {
              heading: '1. सबसे पहले, वह इमेज चुनें जिसे आप क्रॉप करना चाहते हैं। हमारा इमेज क्रॉपर एक बार में कई इमेज चुनने का भी समर्थन करता है।',
              bullets: [
                'इमेज को क्रॉप करने के लिए उसे ड्रॉप बॉक्स में ड्रैग और ड्रॉप करें।',
                'आप क्रॉप बॉक्स में दिए गए choose files बटन पर क्लिक करके file explorer से भी इमेज चुन सकते हैं।',
                'इमेज को ड्रॉप बॉक्स में पेस्ट करने के लिए Ctrl + V शॉर्टकट भी समर्थित है।',
              ],
            },
            {
              heading: '2. फिर, इमेज पर क्रॉप बॉक्स का आकार और स्थिति समायोजित करें ताकि उसे काटा जा सके।',
            },
            {
              heading: '3. आप ऊँचाई, चौड़ाई, क्षैतिज स्थिति और ऊर्ध्वाधर स्थिति के मान मैन्युअली दर्ज करके भी क्रॉप बॉक्स समायोजित कर सकते हैं।',
            },
            {
              heading: '4. आप कुछ प्रीमेड टेम्पलेट्स भी उपयोग कर सकते हैं:',
              bullets: [
                'लैंडस्केप(16:9)',
                'पोर्ट्रेट(9:16)',
                'स्क्वेयर(1:1)',
              ],
            },
            {
              heading: '5. फिर आपको डाउनलोड विकल्पों में से एक चुनना होगा।',
              bullets: [
                'ZIP: यदि आप कई इमेज क्रॉप कर रहे हैं और सभी क्रॉप की गई इमेज एक ही फ़ाइल में डाउनलोड करना चाहते हैं, तो यह विकल्प चुनें।',
                'Separate: यदि आप सभी क्रॉप की गई इमेज अलग-अलग डाउनलोड करना चाहते हैं, तो टॉगल बटन से यह विकल्प चुनें।',
              ],
            },
            {
              heading: '6. फिर Crop & Download बटन पर क्लिक करें ताकि आपकी सभी क्रॉप की गई इमेज आपकी preset dimensions के अनुसार डाउनलोड हो जाएँ।',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. इमेज क्रॉपर के लाभ: इमेज क्रॉपर टूल डिजिटल दुनिया में कई लाभ प्रदान करता है। कुछ नीचे वर्णित हैं:',
          tocLabel: '4. इमेज क्रॉपर के लाभ',
          bullets: [
            'फ्रेम में इमेज फिट करना: इमेज क्रॉपर आपको इमेज को फ्रेम में सही तरीके से फिट करने में मदद करता है। ये फ्रेम किसी वेबपेज पर या किसी सोशल मीडिया प्लेटफ़ॉर्म पर हो सकते हैं।',
            'UX को बढ़ाना: क्योंकि इमेज की सही प्लेसिंग यूज़र अनुभव को बढ़ाती है, इमेज क्रॉपर UX को काफी हद तक बढ़ाने में मदद करता है।',
            'अनचाही बॉर्डर हटाना: आप इमेज से किसी भी अनचाही बॉर्डर को हटाकर उसे परिष्कृत कर सकते हैं।',
            'चाहे गए ऑब्जेक्ट को अलग करना: आप ग्रुप फोटो से अपनी इमेज को अलग भी कर सकते हैं।',
            'स्टोरेज बचाना: इमेज क्रॉप करने से निश्चित रूप से स्टोरेज बचती है क्योंकि इमेज का कच्चा क्षेत्र काट दिया जाता है और केवल आवश्यक भाग ही सहेजा जाता है।',
            'प्रेजेंटेशन अनुकूलन: क्योंकि 10 बिना क्रॉप की गई इमेज वाली सामान्य प्रेजेंटेशन लगभग 30MB स्टोरेज लेती है, वही प्रेजेंटेशन क्रॉप की गई इमेज के साथ लगभग 10MB स्टोरेज ले सकती है।',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. समर्थित फॉर्मेट:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'फोटो एडिटर — फोटो ऑनलाइन मुफ्त में एडिट करें | photremium.com',
      desc: 'फोटो ऑनलाइन मुफ्त में एडिट करें — टेक्स्ट, इफेक्ट, फ्रेम और अधिक जोड़ें।',
      keywords: 'फोटो एडिटर, फोटो ऑनलाइन एडिट करें',
    },
    title: 'फोटो एडिटर',
    desc: 'इमेज में टेक्स्ट, इफेक्ट, फ्रेम और स्टिकर जोड़ें।',
    toEdit: 'एडिट करने के लिए',
    textTypography: 'टेक्स्ट और टाइपोग्राफी',
    textTypographyDesc: 'अलग-अलग फ़ॉन्ट, रंग और छाया के साथ कस्टम टेक्स्ट जोड़ें।',
    filtersEffects: 'फिल्टर और इफेक्ट',
    filtersEffectsDesc: 'प्रोफेशनल फिल्टर लगाएं, ब्राइटनेस, कंट्रास्ट और सैचुरेशन समायोजित करें।',
    framesStickers: 'फ्रेम और स्टिकर',
    framesStickersDesc: 'इमेज सुधारने के लिए खूबसूरत फ्रेम और मजेदार स्टिकर चुनें।',
  },

  removeBg: {
    seo: {
      uploadTitle: 'इमेज का बैकग्राउंड मुफ्त में हटाएं | photremium.com',
      uploadDesc: 'इमेज बैकग्राउंड तेज़ी से और सटीक रूप से हटाएं। मुफ्त।',
      uploadKeywords: 'बैकग्राउंड हटाएं, इमेज बैकग्राउंड हटाएं, पारदर्शी बैकग्राउंड',
      workspaceTitle: 'बैकग्राउंड हटाएं — photremium.com',
      workspaceDesc: 'इमेज बैकग्राउंड ऑनलाइन मुफ्त में हटाएं।',
      workspaceKeywords: 'बैकग्राउंड हटाएं',
    },
    title: 'बैकग्राउंड हटाएं',
    desc: 'इमेज बैकग्राउंड तुरंत हटाएं। 100% मुफ्त, ब्राउज़र में चलता है।',
    toRemoveBg: 'बैकग्राउंड हटाएं',
    backgroundRemover: 'बैकग्राउंड रिमूवर',
    processingProgress: 'प्रोसेसिंग प्रगति',
    processingNImages: '{n} इमेज प्रोसेस हो रही है…',
    allNProcessed: 'सभी {n} इमेज प्रोसेस हो गई!',
    nOfTotalDone: '{n} / {total} पूरा',
    fileName: 'फाइल नाम',
    dimensions: 'आयाम',
    status: 'स्थिति',
    statusDone: '✓ पूरा',
    statusProcessing: '⏳ प्रोसेसिंग',
    statusError: '✗ त्रुटि',
    statusPending: '⏸ प्रतीक्षारत',
    badgeDone: 'पूरा',
    badgeProcessing: 'प्रोसेसिंग…',
    badgeError: 'त्रुटि',
    removingBg: 'बैकग्राउंड हटाया जा रहा है…',
    retry: 'पुनः प्रयास करें',
    downloading: 'डाउनलोड हो रहा है…',
    nextImage: 'अगली इमेज',
  },

  watermark: {
    seo: {
      uploadTitle: 'वॉटरमार्क ऑनलाइन मुफ्त में जोड़ें | photremium.com',
      uploadDesc: 'फोटो में टेक्स्ट या इमेज वॉटरमार्क जोड़ें। मुफ्त और तेज़।',
      uploadKeywords: 'वॉटरमार्क, वॉटरमार्क जोड़ें',
      workspaceTitle: 'वॉटरमार्क जोड़ें — photremium.com',
      workspaceDesc: 'वॉटरमार्क ऑनलाइन मुफ्त में जोड़ें।',
      workspaceKeywords: 'वॉटरमार्क',
    },
    title: 'वॉटरमार्क जोड़ें',
    desc: 'इमेज में टेक्स्ट या लोगो वॉटरमार्क जोड़ें।',
    toWatermark: 'वॉटरमार्क के लिए',
    watermarkTools: 'वॉटरमार्क टूल',
    addText: 'टेक्स्ट जोड़ें',
    addImage: 'इमेज जोड़ें',
    layersN: 'लेयर्स ({n})',
    noLayers: 'अभी तक कोई लेयर नहीं जोड़ी गई',
    textLayer: 'टेक्स्ट लेयर',
    imageLayer: 'इमेज लेयर',
    watermarkDownloadAll: 'वॉटरमार्क और सभी डाउनलोड करें',
    watermarkDownload: 'वॉटरमार्क और डाउनलोड करें',
    nextImage: 'अगली इमेज',
    privateMode: 'निजी मोड',
    privateModeOn: 'निजी मोड चालू: वॉटरमार्क केवल मूव और स्केल करें…',
    privateModeHint: 'केवल स्थिति और साइज़ समायोजित करने के लिए निजी मोड चालू करें…',
    privateModeActive: 'निजी मोड — केवल मूव, स्केल और फ़ॉन्ट साइज़ अनुमत',
    selectToEdit: 'एडिट शुरू करने के लिए कोई इमेज या टेक्स्ट चुनें',
    bold: 'बोल्ड',
    italic: 'इटैलिक',
    underline: 'अंडरलाइन',
    bgColor: 'बैकग्राउंड रंग',
    textColor: 'टेक्स्ट रंग',
    alignLeft: 'बाएं संरेखित',
    alignCenter: 'केंद्र',
    alignRight: 'दाएं संरेखित',
    opacity: 'अपारदर्शिता',
    stroke: 'स्ट्रोक',
    strokeWidth: 'स्ट्रोक चौड़ाई',
    strokeColor: 'स्ट्रोक रंग',
    tileRepeat: 'टाइल / दोहराएं',
    tilePattern: 'टाइल पैटर्न',
    spacing: 'अंतराल',
    snapToCenter: 'केंद्र में स्नैप करें',
    duplicate: 'डुप्लिकेट',
    delete: 'हटाएं',
    flipHorizontal: 'क्षैतिज पलटें',
    flipVertical: 'ऊर्ध्वाधर पलटें',
    rotateLeft: 'बाएं घुमाएं',
    rotateRight: 'दाएं घुमाएं',
    cornerRadius: 'कोने का त्रिज्या',
    borderStroke: 'बॉर्डर / स्ट्रोक',
    borderWidth: 'बॉर्डर चौड़ाई',
    color: 'रंग',
    style: 'स्टाइल',
    hide: 'छुपाएं',
    show: 'दिखाएं',
    lock: 'लॉक करें',
    unlock: 'अनलॉक करें',
    solid: 'ठोस',
    dashed: 'धराशायी',
    dotted: 'बिंदीदार',
    double: 'दोहरा',
    tileSingle: 'एकल',
    tile2x2: '2×2 ग्रिड',
    tile3x3: '3×3 ग्रिड',
    removeAllConfirm: 'सभी इमेज और वॉटरमार्क हटाएं?',
    dimMismatch: 'अपलोड की गई इमेज के आयाम अलग हैं। सर्वोत्तम परिणामों के लिए समान रेजोल्यूशन वाली इमेज अपलोड करें।',
    clearBackground: 'बैकग्राउंड साफ़ करें',
    typeHere: 'यहाँ टाइप करें...',
    linkCorners: 'कोने लिंक करें',
    separateCorners: 'कोने अलग करें',
    blog: {
      tocTitle: 'सामग्री',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'वॉटरमार्क टूल ओवरव्यू',
          title: 'ऑनलाइन अपनी इमेज पर वॉटरमार्क कैसे जोड़ें — Photremium के वॉटरमार्क टूल की पूरी गाइड',
          paragraphs: [
            'आपने अभी-अभी एक खूबसूरत फोटो एडिट की है। शायद यह आपकी दुकान के लिए कोई प्रोडक्ट शॉट है, किसी क्लाइंट सेशन का पोर्ट्रेट है, या घंटों लगाकर तैयार की गई डिजिटल आर्टवर्क है। और अब वह सवाल आता है जिसका सामना हर क्रिएटर को करना पड़ता है: इसे शेयर करने से पहले इसे कैसे सुरक्षित करें?',
            'अधिकांश प्रोफेशनल्स का जवाब होता है: वॉटरमार्क — और इसके अच्छे कारण हैं। सही जगह लगाया गया वॉटरमार्क आपके काम पर स्थायी हस्ताक्षर की तरह काम करता है, उसे ट्रेसेबल और ब्रांडेड बनाता है, और चोरी करना काफी मुश्किल कर देता है।',
            'अधिकांश लोगों को जो समस्या आती है वह यह है कि ऑनलाइन उपलब्ध टूल या तो बहुत भारी होते हैं, सब्सक्रिप्शन के पीछे लॉक होते हैं, या फिर इतना भारी वॉटरमार्क बना देते हैं कि इमेज ही खराब लगने लगती है।',
            'Photremium का वॉटरमार्क इमेज टूल इन सब को ठीक करने के लिए बनाया गया है। यह पूरी तरह ब्राउज़र-आधारित, मुफ्त, बिना अकाउंट वाला वॉटरमार्किंग वर्कस्पेस है जो आपकी फाइल्स को कभी सर्वर पर अपलोड किए बिना सीधे आपके ब्राउज़र में चलता है। सब कुछ लोकल रहता है, सब कुछ तेज़ रहता है, और इसका क्रिएटिव कंट्रोल उस स्तर का है जिसकी उम्मीद आप डेस्कटॉप सॉफ्टवेयर से करते हैं। इस गाइड में हम आपको बताएंगे कि यह कैसे काम करता है, यह किनके लिए बना है, और हर बार सबसे अच्छे रिज़ल्ट कैसे हासिल करें।',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'वॉटरमार्क क्या है',
          title: 'वॉटरमार्क क्या है और यह क्यों जरूरी है?',
          paragraphs: [
            'टूल में जाने से पहले यह समझना जरूरी है कि वॉटरमार्क क्या करता है और इतने फोटोग्राफर, डिज़ाइनर और कंटेंट क्रिएटर इसे क्यों अनिवार्य मानते हैं।',
            'वॉटरमार्क इमेज पर जोड़ा जाने वाला एक दिखाई देने वाला ओवरले होता है — आमतौर पर टेक्स्ट, लोगो या कॉपीराइट सिंबल — जो कंटेंट के क्रिएटर या मालिक की पहचान बताता है। मेटाडेटा के विपरीत (जो फाइल के अंदर छिपा होता है और सेकंडों में हटाया जा सकता है), वॉटरमार्क विज़ुअली इमेज में ही एम्बेड होता है। आप इसे बिना क्वालिटी गिराए बस राइट-क्लिक करके नहीं हटा सकते।',
          ],
          subSections: [
            {
              title: 'क्रिएटर्स वॉटरमार्क क्यों इस्तेमाल करते हैं',
              paragraphs: [
                'इमेज पर वॉटरमार्क लगाने के व्यावहारिक कारण तीन मुख्य बातों तक आते हैं।',
              ],
              bullets: [
                'स्वामित्व की पहचान। जब आपका काम सोशल मीडिया प्लेटफॉर्म्स, Pinterest बोर्ड्स या ब्लॉग पोस्ट्स में साझा होता है, तो मूल श्रेय अक्सर हट जाता है। वॉटरमार्क यह सुनिश्चित करता है कि आपका नाम या ब्रांड इमेज के साथ बना रहे।',
                'चोरी से बचाव। अधिकांश कैज़ुअल इमेज चोर आसान रास्ता ढूंढते हैं। एक प्रोफेशनल दिखने वाला, सही जगह लगा हुआ और थोड़ा पारदर्शी वॉटरमार्क स्पष्ट संदेश देता है: यह इमेज किसी ऐसे व्यक्ति की है जो अपने काम की परवाह करता है।',
                'क्लाइंट पोर्टफोलियो सुरक्षा। जो फोटोग्राफर फाइनल पेमेंट से पहले क्लाइंट्स को प्रीव्यू देते हैं, वे अक्सर वॉटरमार्क का उपयोग करते हैं ताकि क्लाइंट बिना भुगतान किए प्रीव्यू का उपयोग न करें। एक सूक्ष्म वॉटरमार्क यह सुनिश्चित करता है कि प्रीव्यू का मूल्यांकन बाधित न हो।',
              ],
            },
            {
              title: 'किसे अपनी इमेज पर वॉटरमार्क लगाना चाहिए',
              paragraphs: [
                'अगर आप निम्न में से किसी भी श्रेणी में आते हैं, तो ऑनलाइन शेयर करने से पहले वॉटरमार्क लगाना वैकल्पिक नहीं — यह आवश्यक है:',
              ],
              bullets: [
                'फ्रीलांस फोटोग्राफर जो क्लाइंट्स के साथ गैलरी साझा करते हैं',
                'ग्राफिक डिज़ाइनर जो पोर्टफोलियो सैंपल्स वितरित करते हैं',
                'ई-कॉमर्स सेलर्स जो लाइसेंसिंग डील से पहले प्रोडक्ट फोटो दिखाते हैं',
                'डिजिटल आर्टिस्ट जो सोशल प्लेटफॉर्म्स पर काम साझा करते हैं',
                'ब्लॉगर्स और कंटेंट क्रिएटर जिनकी इमेज नियमित रूप से दोबारा इस्तेमाल होती हैं',
                'स्टॉक फोटो कंट्रीब्यूटर्स जो एक पहचानने योग्य ब्रांड बनाते हैं',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'वर्कस्पेस पैनल',
          title: 'Photremium के वॉटरमार्क टूल के अंदर: वास्तविक वर्कफ़्लो के लिए तीन-पैनल वर्कस्पेस',
          paragraphs: [
            'Photremium के वॉटरमार्क टूल को साधारण ऑनलाइन वॉटरमार्करों से अलग बनाने वाली चीज़ उसका वर्कस्पेस डिज़ाइन है। “टेक्स्ट टाइप करो, पोजिशन चुनो, हो गया” जैसे सरल फ्लो के बजाय, यह टूल तीन-पैनल लेआउट देता है जो प्रोफेशनल डिज़ाइन सॉफ़्टवेयर जैसा लगता है — बस यह पूरी तरह आपके ब्राउज़र में चलता है, बिना किसी इंस्टॉलेशन के।',
          ],
          subSections: [
            {
              title: 'बायां कैनवस पैनल',
              paragraphs: [
                'कैनवस पैनल स्क्रीन का सबसे बड़ा हिस्सा होता है और रियल टाइम में दिखाता है कि वॉटरमार्क के साथ आपकी इमेज कैसी दिखती है। आप जो भी बदलाव करते हैं — अपारदर्शिता बदलना, टेक्स्ट लेयर की पोजिशन बदलना, लोगो का साइज़ बदलना — वह तुरंत कैनवस पर दिखता है। कोई “प्रिव्यू” बटन नहीं है। जो दिखता है वही मिलेगा।',
                'कैनवस में बिल्ट-इन ज़ूम टूलबार होता है, जिससे आप सटीक एलाइनमेंट के लिए ज़ूम इन और बड़े दृश्य के लिए ज़ूम आउट कर सकते हैं। ज़ूम-टू-फिट फीचर आपके स्क्रीन साइज़ के आधार पर सबसे अच्छा शुरुआती स्केल अपने-आप सेट करता है, ताकि हाई-रेज़ इमेज भी आरामदायक साइज़ पर लोड हों। जब आप लेयर को इमेज के क्षैतिज या ऊर्ध्वाधर केंद्र के पास खींचते हैं, तो एलाइनमेंट गाइड्स अपने-आप दिखते हैं और वॉटरमार्क को बिल्कुल केंद्र में स्नैप कर देते हैं — वह सटीकता जो आमतौर पर केवल Photoshop में मिलती है।',
              ],
            },
            {
              title: 'दायां सेटिंग्स पैनल',
              paragraphs: [
                'दायां पैनल कंट्रोल सेंटर है। यहीं आप वॉटरमार्क लेयर्स मैनेज करते हैं, उनकी appearance कस्टमाइज करते हैं, और अंतिम एक्सपोर्ट ट्रिगर करते हैं। डेस्कटॉप पर यह स्क्रीन के दाईं ओर फिक्स रहता है। मोबाइल पर यह नीचे से बॉटम शीट की तरह स्लाइड होता है — एक फ्लोटिंग गियर बटन से — ताकि काम करते समय कैनवस ढका न रहे।',
                'दाएं पैनल में लेयर मैनेजर होता है, जो आपके द्वारा जोड़े गए हर वॉटरमार्क एलिमेंट को सूचीबद्ध करता है। हर लेयर एंट्री में लेयर टाइप (टेक्स्ट या इमेज), उसका नाम/कंटेंट, और तीन क्विक-एक्शन बटन होते हैं: विज़िबिलिटी टॉगल (आंख का आइकन), लॉक टॉगल ताकि आप किसी लेयर की पोजिशन फ्रीज़ कर सकें, और डिलीट बटन।',
              ],
            },
            {
              title: 'बायां प्रिव्यू स्ट्रिप (मल्टी-इमेज मोड)',
              paragraphs: [
                'जब आप एक साथ कई इमेज पर काम करते हैं — जैसे प्रोडक्ट फोटोज का बैच या पूरा पोर्ट्रेट सेशन — तो स्क्रीन के बाईं ओर एक वर्टिकल थंबनेल स्ट्रिप दिखाई देती है। यह इमेज क्यू है, जिसमें आपकी सभी फाइल्स के छोटे प्रिव्यू होते हैं। किसी भी थंबनेल पर क्लिक करते ही कैनवस तुरंत उस इमेज पर स्विच हो जाता है, जिससे आप अलग-अलग कंपोज़िशन पर वॉटरमार्क कैसा दिख रहा है, यह चेक कर सकते हैं — बिना लेयर सेटिंग खोए।',
                'यह स्ट्रिप हर फाइल का साइज (KB या MB में) और फॉर्मेट टैग (JPG, PNG, WEBP) भी दिखाती है, ताकि आप एक नजर में समझ सकें कि आप किस फाइल पर काम कर रहे हैं।',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'स्टेप-बाय-स्टेप',
          title: 'स्टेप-बाय-स्टेप: Photremium में अपनी इमेज पर वॉटरमार्क कैसे जोड़ें',
          paragraphs: [
            'यह वॉकथ्रू ठीक उसी तरीके पर आधारित है जैसे टूल अंदर से काम करता है — ड्रैग-एंड-ड्रॉप अपलोड सिस्टम से लेकर कैनवस रेंडरिंग इंजन तक, जो डाउनलोड से पहले वॉटरमार्क को स्थायी रूप से इमेज पर लिखता है।',
          ],
          steps: [
            {
              heading: 'स्टेप 1 — अपनी इमेज/इमेजेस अपलोड करें',
              paragraphsBefore: [
                'photremium.com/watermark-image पर जाएं। आप अपलोड स्क्रीन पर पहुंचेंगे, जहां पेज के बीच में एक साफ ड्रैग-एंड-ड्रॉप ड्रॉपज़ोन होता है।',
                'आपके पास इमेज लोड करने के तीन तरीके हैं:',
              ],
              bullets: [
                'Drag and drop. अपनी डेस्कटॉप से एक या अधिक इमेज फाइल्स सीधे ड्रॉपज़ोन पर खींचें। यह टूल JPEG, PNG, WEBP और अन्य स्टैंडर्ड फॉर्मेट स्वीकार करता है। जब आप फाइल्स को वर्कस्पेस पर लाते हैं, तो एक बैंगनी बॉर्डर और “Drop images to add for watermarking” संदेश दिखाई देता है, जिससे पता चलता है कि ड्रॉप रजिस्टर हो रहा है।',
                'Click to browse. ड्रॉपज़ोन के अंदर “Choose Files” बटन पर क्लिक करके फाइल पिकर खोलें। आप Ctrl+Click (Windows) या Cmd+Click (Mac) से एक साथ कई फाइल्स चुन सकते हैं।',
                'Paste from clipboard. अगर आपने क्लिपबोर्ड में कोई इमेज कॉपी की है — स्क्रीनशॉट, दूसरी ऐप या ब्राउज़र से — तो वॉटरमार्क पेज पर Ctrl+V (या Mac पर Cmd+V) दबाएं और इमेज सीधे वर्कस्पेस में लोड हो जाएगी। यह तब भी काम करता है जब कई इमेज पहले से लोड हों।',
              ],
              paragraphsAfter: [
                'जैसे ही पहली इमेज लोड होती है, वर्कस्पेस अपलोड स्क्रीन से फुल तीन-पैनल एडिटर में बदल जाता है, और कैनवस आपकी इमेज को ऑटोमैटिक फिट-टू-स्क्रीन ज़ूम लेवल पर दिखाता है।',
              ],
            },
            {
              heading: 'स्टेप 2 — टेक्स्ट वॉटरमार्क लेयर जोड़ें',
              paragraphsBefore: [
                'दाएं पैनल में बैंगनी “Add Text” बटन पर क्लिक करें। कैनवस पर एक नई टेक्स्ट लेयर दिखाई देगी जिसमें डिफॉल्ट प्लेसहोल्डर टेक्स्ट “Type here...” पहले से चुना हुआ होगा।',
                'आप तुरंत टाइप करना शुरू कर सकते हैं। टेक्स्ट कैनवस पर लाइव रेंडर होता है और डिफॉल्ट साइज के साथ सफेद Arial में दिखाई देता है। टेक्स्ट लेयर चयनित होने पर जो टॉप टूलबार दिखता है, वहां से आप टेक्स्ट के हर पहलू को कस्टमाइज कर सकते हैं:',
              ],
              bullets: [
                'Font family — Arial, Georgia, Impact, Brush Script MT, Comic Sans MS सहित 12 बिल्ट-इन फॉन्ट चुनें',
                'Font size — पिक्सेल वैल्यू टाइप करें या इन्क्रीमेंट कंट्रोल्स उपयोग करें',
                'Bold, italic, underline — इन स्टाइल्स का कोई भी कॉम्बिनेशन चुनें',
                'Text color — कलर स्वैच पर क्लिक करके कोई भी हेक्स कलर चुनें',
                'Background color — टेक्स्ट के पीछे रंगीन बैकग्राउंड जोड़ें ताकि लेबल/बैज जैसा लुक मिले',
                'Stroke (outline) — हल्की और गहरी दोनों इमेज पर पठनीयता के लिए स्ट्रोक की चौड़ाई और रंग सेट करें',
                'Opacity — 0% (अदृश्य) से 100% (पूर्ण) तक स्लाइड करें; अधिकांश वॉटरमार्क 30% से 60% के बीच रहते हैं',
                'Alignment — टेक्स्ट को उसके बॉक्स में बाएं, केंद्र या दाएं संरेखित करें',
                'Rotation — टेक्स्ट लेयर को किसी भी एंगल पर घुमाएं, 0°, 90°, 180° और 270° पर मैग्नेटिक स्नैप पॉइंट्स के साथ',
              ],
              paragraphsAfter: [
                'टेक्स्ट को मूव करने के लिए उसे क्लिक करके ड्रैग करें। पिक्सेल-परफेक्ट पोजिशनिंग के लिए कीबोर्ड की एरो कीज़ इस्तेमाल करें (Shift दबाने पर 10-पिक्सेल स्टेप्स)। टेक्स्ट बॉक्स को री-साइज़ करने के लिए चयनित लेयर के चारों ओर दिखने वाले आठ हैंडल्स (कोने और किनारे) को ड्रैग करें।',
              ],
            },
            {
              heading: 'स्टेप 3 — इमेज (लोगो) वॉटरमार्क लेयर जोड़ें',
              paragraphsBefore: [
                'यदि आप टेक्स्ट की बजाय — या साथ में — कोई लोगो, सिग्नेचर या इमेज वॉटरमार्क इस्तेमाल करना चाहते हैं, तो दाएं पैनल में नीला “Add Image” बटन क्लिक करें। आपका फाइल पिकर खुलेगा और आप अपने डिवाइस से वॉटरमार्क इमेज चुन सकेंगे।',
                'टूल वॉटरमार्क इमेज को उसके मूल आस्पेक्ट रेशियो के साथ बनाए रखते हुए कैनवस की चौड़ाई का लगभग 30% अपने-आप सेट कर देता है और उसे केंद्र में रख देता है। वहां से आप उसे किसी भी जगह ड्रैग कर सकते हैं, कोनों के हैंडल से री-साइज़ कर सकते हैं (आस्पेक्ट रेशियो लॉक रहता है), या चयनित लेयर के ऊपर दिखने वाले रोटेट हैंडल से घुमा सकते हैं।',
                'इमेज-टाइप वॉटरमार्क लेयर्स के लिए दायां पैनल अतिरिक्त कंट्रोल्स दिखाता है:',
              ],
              bullets: [
                'Opacity — टेक्स्ट लेयर्स जैसा ही, पारदर्शी PNG लोगो के लिए आदर्श',
                'Flip horizontal / Flip vertical — जरूरत पड़े तो वॉटरमार्क को मिरर करें',
                'Border width, border color, and border style — लोगो वॉटरमार्क के चारों ओर विज़िबल बॉर्डर जोड़ें',
                'Border radius — लोगो के कोनों को गोल करें, समान रूप से या प्रत्येक कोने के लिए अलग नियंत्रण के साथ',
                'Rotation — टेक्स्ट लेयर जैसा स्मूद रोटेशन व्यवहार',
              ],
            },
            {
              heading: 'स्टेप 4 — टाइलिंग सेट करें (वैकल्पिक)',
              paragraphsBefore: [
                'टूल की एक शक्तिशाली सुविधा टाइलिंग है — पूरे इमेज पर वॉटरमार्क को ग्रिड पैटर्न में दोहराने की क्षमता। यह खास तौर पर तब उपयोगी है जब आप इमेज को रीपब्लिकेशन के लिए अनुपयोगी बनाना चाहते हैं, सिर्फ ब्रांडिंग के लिए नहीं।',
                'किसी लेयर को चुनें और टूलबार में टाइल ऑप्शन देखें। आप इसे सेट कर सकते हैं:',
              ],
              bullets: [
                'None — एकल प्लेसमेंट (डिफॉल्ट)',
                'Grid 2×2 — वॉटरमार्क को 2-कॉलम, 2-रो पैटर्न में दोहराता है',
                'Grid 3×3 — अधिक घना कवरेज के लिए 3×3 ग्रिड',
              ],
              paragraphsAfter: [
                'आप टाइल स्पेसिंग भी एडजस्ट कर सकते हैं, जो प्रत्येक रिपीटेड कॉपी के बीच का गैप नियंत्रित करता है। कैनवस पर सभी टाइल्ड कॉपीज़ के घोस्ट प्रिव्यू दिखते हैं ताकि आप डाउनलोड से पहले पूरा कवरेज पैटर्न देख सकें।',
              ],
            },
            {
              heading: 'स्टेप 5 — कई वॉटरमार्क के लिए लेयर मैनेजर का उपयोग करें',
              paragraphsBefore: [
                'आप जितनी चाहें उतनी लेयर्स जोड़ सकते हैं — टेक्स्ट और इमेज वॉटरमार्क को मिक्स करके। दाएं पैनल का लेयर मैनेजर सबको सूचीबद्ध करता है। आप ये कर सकते हैं:',
              ],
              bullets: [
                'आंख के आइकन से व्यक्तिगत लेयर्स दिखाएं/छुपाएं — अलग-अलग वॉटरमार्क वर्ज़न के बीच स्विच करने के लिए उपयोगी',
                'किसी लेयर को लॉक करें ताकि अन्य लेयर्स पर काम करते समय वह गलती से न हिले',
                'किसी लेयर को स्थायी रूप से डिलीट करें',
              ],
              paragraphsAfter: [
                'लिस्ट में किसी भी लेयर एंट्री पर क्लिक करते ही वह कैनवस पर चयनित हो जाती है, जिससे इमेज में ढूंढे बिना लेयर्स के बीच स्विच करना आसान होता है।',
              ],
            },
            {
              heading: 'स्टेप 6 — कई इमेज के बीच स्विच करें',
              paragraphsBefore: [
                'अगर आपने एक से ज्यादा इमेज अपलोड की है, तो बाईं ओर थंबनेल स्ट्रिप का उपयोग करके एक्टिव कैनवस इमेज बदलें। आपने जो वॉटरमार्क लेयर्स कॉन्फ़िगर की हैं, वे सभी इमेज पर लागू होंगी — एक्सपोर्ट के समय वे हर इमेज पर रेंडर होंगी।',
                'टूल आपके बैच में रेज़ोल्यूशन कंसिस्टेंसी भी जांचता है। यदि इमेज के आयामों में बड़ा अंतर है (चौड़ाई या ऊंचाई में 5% से अधिक), तो एक चेतावनी दिखाई देती है जो बताती है कि साइज वेरिएशन के कारण वॉटरमार्क की पोजिशन अलग दिख सकती है। इंजन इसे प्रोपोर्शनल री-पोजिशनिंग एल्गोरिद्म से संभालता है: यह वॉटरमार्क की पोजिशन को रेफरेंस इमेज के आयामों के प्रतिशत के रूप में गणना करता है और वही अनुपात बाकी सभी इमेज पर लागू करता है, ताकि अलग-अलग रेज़ोल्यूशन के बावजूद विज़ुअल इंटेंट बना रहे।',
              ],
            },
            {
              heading: 'स्टेप 7 — डाउनलोड प्रेफरेंसेज़ सेट करें',
              paragraphsBefore: [
                'सिंगल इमेज के लिए, कैनवस के नीचे “Download” बटन पर क्लिक करें और वॉटरमार्क वाली इमेज सीधे सेव करें। फाइलनाम अपने-आप आपके मूल फाइलनाम के साथ “-watermarked” जोड़कर बन जाता है। JPEG इमेज 0.95 क्वालिटी पर एक्सपोर्ट होती हैं — सामान्य देखने पर मूल इमेज से अलग पहचानना मुश्किल होता है। PNG इमेज lossless PNG के रूप में एक्सपोर्ट होती हैं।',
                'बैच जॉब्स (कई इमेज) के लिए, दाएं पैनल में दो डाउनलोड मोड उपलब्ध हैं:',
              ],
              bullets: [
                'ZIP file — सभी वॉटरमार्क्ड इमेज एक ZIP आर्काइव में पैक होकर एक क्लिक में डाउनलोड होती हैं। टूल कंप्रेशन के लिए JSZip को डायनेमिकली लोड करता है।',
                'Separate files — हर इमेज अलग-अलग फाइल के रूप में डाउनलोड होती है, और ब्राउज़र थ्रॉटलिंग रोकने के लिए प्रत्येक डाउनलोड के बीच छोटा अंतर रखा जाता है।',
              ],
            },
            {
              heading: 'स्टेप 8 — डाउनलोड और जांच करें',
              paragraphsBefore: [
                'डाउनलोड बटन (या बैच के लिए “Watermark & Download All” बटन) पर क्लिक करने के बाद, टूल हर इमेज को छिपे हुए HTML5 कैनवस एलिमेंट पर फुल नेटिव रेज़ोल्यूशन में रेंडर करता है — स्क्रीन पर दिखने वाले स्केल्ड प्रिव्यू साइज पर नहीं। इसका मतलब है कि एक्सपोर्ट की गई इमेज 100% मूल पिक्सेल आयामों पर होती है, और वॉटरमार्क उसी अनुपात में सही आकार में ड्रॉ होता है। डाउनलोड की गई फाइल खोलें और ज़ूम करके देखें कि वॉटरमार्क की पोजिशन और क्वालिटी आपकी उम्मीद के अनुसार है।',
                'अगर कुछ भी गलत लगे, तो बस वर्कस्पेस पर लौटें — आपकी लेयर्स अभी भी वहीं हैं — एडजस्ट करें और फिर से डाउनलोड करें।',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'प्रो टिप्स',
          title: 'बेहतरीन परिणामों के लिए प्रो टिप्स',
          bullets: [
            'अधिक प्रोफेशनल लुक के लिए सेमी-ट्रांसपेरेंट PNG लोगो का उपयोग करें। 40–50% अपारदर्शिता वाला लोगो वॉटरमार्क ठोस टेक्स्ट से ज्यादा पॉलिश्ड दिखता है। इमेज लेयर के रूप में इस्तेमाल करने से पहले अपने डिज़ाइन टूल से लोगो को अल्फा ट्रांसपेरेंसी के साथ PNG में एक्सपोर्ट करें।',
            'वॉटरमार्क को ऐसी जगह रखें जहां क्रॉप करने से मूल्य कम हो। नीचे-दाएं कोना सबसे आम जगह है — और सबसे आसान क्रॉप भी। अधिक सुरक्षा के लिए, वॉटरमार्क को इमेज के किसी महत्वपूर्ण हिस्से पर रखें, जैसे चेहरा, प्रोडक्ट डिटेल, या फोकल पॉइंट। डायगोनल टाइल विकल्प इसे हटाना और भी मुश्किल बना देता है बिना इमेज की क्वालिटी गिराए।',
            'कई लेयर्स पर काम करते समय लॉक फीचर का उपयोग करें। जब आप प्राइमरी वॉटरमार्क पोजिशन से संतुष्ट हों, तो उस लेयर को लॉक कर दें और फिर सेकेंडरी लेयर्स जोड़ें। इससे गलती से उसका स्थान नहीं बदलेगा।',
            'इमेज के हल्के और गहरे क्षेत्रों में टेस्ट करें। सफेद वॉटरमार्क उजले आसमान में दिखाई नहीं देता, लेकिन गहरी छाया में स्पष्ट रहता है। नीचे की सामग्री चाहे जो हो, पठनीयता सुनिश्चित करने के लिए हल्का स्ट्रोक या बैकग्राउंड रंग जोड़ें।',
            'कीबोर्ड शॉर्टकट्स हमेशा समय बचाते हैं। एरो कीज़ चयनित लेयर को एक पिक्सेल से मूव करती हैं। Shift+Arrow दस पिक्सेल मूव करता है। Delete की चयनित लेयर को तुरंत हटा देती है। ये शॉर्टकट्स ड्रैग करने की तुलना में फाइन-ट्यूनिंग को बहुत तेज़ बनाते हैं।',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'प्राइवेसी और सुरक्षा',
          title: 'प्राइवेसी और सुरक्षा: ब्राउज़र-आधारित प्रोसेसिंग क्यों महत्वपूर्ण है',
          paragraphs: [
            'ऑनलाइन टूल्स का उपयोग करते समय कई क्रिएटर्स की चिंता होती है कि उनकी इमेज वास्तव में कहां जाती हैं। सर्वर-आधारित वॉटरमार्किंग टूल्स में आपकी इमेज प्रदाता के सर्वर पर अपलोड होती है, वहीं प्रोसेस होती है, और फिर वापस भेजी जाती है। इसका मतलब यह है कि आपका अप्रकाशित काम, क्लाइंट फोटोज, या संवेदनशील प्रोडक्ट इमेज किसी और की इंफ्रास्ट्रक्चर से होकर गुजरती हैं।',
            'Photremium का वॉटरमार्क टूल सब कुछ आपके ब्राउज़र में लोकली प्रोसेस करता है। आपकी इमेज ब्राउज़र की File API से आपके डिवाइस की मेमोरी में लोड होती हैं और इंटरनेट पर कभी ट्रांसमिट नहीं होतीं। वॉटरमार्क रेंडरिंग HTML5 कैनवस एलिमेंट पर JavaScript के माध्यम से होती है, पूरी तरह आपके ब्राउज़र टैब के अंदर। जब आप पेज बंद करते हैं या “Start Over” पर क्लिक करते हैं, तो सभी इमेज डेटा मेमोरी से रिलीज़ होकर हटा दिए जाते हैं। आपकी डिवाइस के बाहर कहीं कुछ भी स्टोर नहीं होता।',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'अंतिम सारांश',
          title: 'क्यों Photremium का वॉटरमार्क टूल आपके नियमित वर्कफ़्लो में जगह पाने योग्य है',
          paragraphs: [
            'ऑनलाइन दर्जनों वॉटरमार्किंग टूल उपलब्ध हैं। किसी टूल को बुकमार्क करने लायक बनाने वाली चीज़ आमतौर पर गति, नियंत्रण और भरोसेमंदी का मेल होती है।',
            'गति महत्वपूर्ण है क्योंकि वॉटरमार्किंग आपके पोस्ट-प्रोसेसिंग वर्कफ़्लो में ज्यादा समय नहीं जोड़नी चाहिए। Photremium टूल तुरंत लोड होता है, लोकली प्रोसेस करता है, और सेकंडों में फुल रेज़ोल्यूशन पर एक्सपोर्ट कर देता है — यहां तक कि बड़े बैच के लिए भी। कोई सर्वर-साइड वेटिंग, कोई क्यू, और कोई ऐसा रेंडर टाइम नहीं जो एक साथ ऑनलाइन यूज़र्स की संख्या के साथ बढ़े।',
            'नियंत्रण महत्वपूर्ण है क्योंकि गलत दिखने वाला वॉटरमार्क, बिना वॉटरमार्क के भी बदतर है — यह आपके ब्रांड को अनप्रोफेशनल दिखा सकता है। लेयर सिस्टम, टूलबार के पर-प्रॉपर्टी कंट्रोल्स, रियल-टाइम कैनवस प्रिव्यू, और कीबोर्ड शॉर्टकट सपोर्ट मिलकर ऐसा नियंत्रण देते हैं जो वास्तव में डेडिकेटेड डेस्कटॉप सॉफ़्टवेयर के बराबर है।',
            'भरोसा महत्वपूर्ण है क्योंकि आपका अप्रकाशित काम मूल्यवान है। यह जानना कि आपकी इमेज इंटरनेट के ज़रिए किसी थर्ड-पार्टी सर्वर तक नहीं जाती, इसका मतलब है कि आप क्लाइंट फोटोज, अनरिलीज़्ड प्रोडक्ट इमेज और संवेदनशील क्रिएटिव काम को बिना किसी चिंता के वॉटरमार्क कर सकते हैं — डेटा हैंडलिंग, सर्वर-ब्रीच या क्लाउड प्रोवाइडर की नीति में बदलाव की चिंता किए बिना।',
            'चाहे आप किसी एक फोटो पर जल्दी से कॉपीराइट नोटिस जोड़ रहे हों या क्लाइंट गैलरी के लिए 200 इमेज का पूरा शूट प्रोसेस कर रहे हों, Photremium का वॉटरमार्क इमेज टूल आपको इसे सही तरीके से करने के लिए जरूरी टूल देता है — पूरी तरह मुफ्त, पूरी तरह निजी, और इतनी क्रिएटिव लचीलापन के साथ कि वॉटरमार्क ऐसा लगे जैसे वह इमेज का हिस्सा हो, न कि ऊपर चिपका हुआ।',
            'photremium.com/watermark-image पर जाएं और इसे आज़माएं। आपकी पहली वॉटरमार्क की गई इमेज सच में बस तीस सेकंड दूर है।',
            'Photremium ब्राउज़र-आधारित इमेज एडिटिंग और प्रोसेसिंग टूल्स का एक सूट प्रदान करता है। सभी टूल्स आपके ब्राउज़र में लोकली चलते हैं — आपकी इमेज आपके डिवाइस पर ही रहती हैं।',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'QR कोड जनरेटर — मुफ्त में बनाएं और कस्टमाइज़ करें | photremium.com',
      inputDesc: 'URL, टेक्स्ट, WiFi, संपर्क, ईमेल और Google Maps के लिए कस्टम QR कोड बनाएं।',
      inputKeywords: 'qr कोड जनरेटर, qr कोड बनाएं',
      customizeTitle: 'QR कोड कस्टमाइज़ करें — photremium.com',
      customizeDesc: 'QR कोड का स्टाइल, रंग, फ्रेम और लोगो कस्टमाइज़ करें।',
      customizeKeywords: 'qr कोड कस्टमाइज़, qr कोड रंग',
    },
    title: 'QR कोड जनरेटर',
    desc: 'URL, टेक्स्ट, WiFi, संपर्क, ईमेल और मैप्स के लिए QR कोड जनरेट, कस्टमाइज़ और डाउनलोड करें।',
    generate: 'जनरेट करें',
    scanQrCode: 'QR कोड स्कैन करें',
    tabUrl: 'लिंक / URL',
    tabText: 'टेक्स्ट',
    tabWifi: 'WiFi',
    tabContact: 'संपर्क',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'URL दर्ज करें',
    enterText: 'टेक्स्ट दर्ज करें',
    networkName: 'नेटवर्क नाम (SSID)',
    password: 'पासवर्ड',
    encryption: 'एन्क्रिप्शन',
    hiddenNetwork: 'छुपा हुआ नेटवर्क',
    contactName: 'संपर्क नाम (वैकल्पिक)',
    phoneNumber: 'फोन नंबर',
    emailAddress: 'ईमेल पता',
    subject: 'विषय (वैकल्पिक)',
    body: 'मुख्य सामग्री (वैकल्पिक)',
    searchLocation: 'स्थान खोजें',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'यहाँ टेक्स्ट दर्ज करें…',
    wifiNamePlaceholder: 'मेरा WiFi',
    passwordPlaceholder: 'पासवर्ड',
    contactPlaceholder: 'राम शर्मा',
    phonePlaceholder: '+91 XXXXX XXXXX',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'विषय',
    bodyPlaceholder: 'ईमेल सामग्री…',
    locationPlaceholder: 'शहर, पता, स्थान खोजें…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'कोई नहीं',
    characters: 'अक्षर',
    qrGettingComplex: 'QR कोड जटिल हो रहा है — स्कैन करना कठिन हो सकता है।',
    qrTooComplex: 'QR कोड बहुत जटिल! अधिकांश स्कैनर इसे नहीं पढ़ पाएंगे।',
    generateCustomize: 'जनरेट करें और कस्टमाइज़ करें',
    editQrData: 'QR डेटा संपादित करें',
    styleShape: 'स्टाइल और आकार',
    colorTab: 'रंग',
    framesTab: 'फ्रेम',
    logoTab: 'लोगो',
    templatesTab: 'टेम्पलेट्स',
    fileFormatTab: 'फाइल फॉर्मेट',
    dotShape: 'बिंदु आकार',
    cornerEyeOuter: 'कोने की आंख — बाहर',
    cornerEyeInner: 'कोने की आंख — अंदर',
    fgColor: 'अग्रभूमि रंग',
    bgColor: 'पृष्ठभूमि रंग',
    enableGradient: 'ग्रेडिएंट सक्षम करें',
    gradientType: 'ग्रेडिएंट प्रकार',
    linear: 'रैखिक',
    radial: 'रेडियल',
    gradientColor1: 'ग्रेडिएंट रंग 1',
    gradientColor2: 'ग्रेडिएंट रंग 2',
    suggestedGradients: 'सुझाए गए ग्रेडिएंट',
    selectFrame: 'फ्रेम चुनें',
    selectLogo: 'लोगो चुनें',
    uploadCustomLogo: 'या कस्टम लोगो अपलोड करें',
    uploadImage: 'इमेज अपलोड करें',
    customLogoApplied: 'कस्टम लोगो लागू',
    premadeTemplates: 'तैयार टेम्पलेट्स',
    templateHint: 'स्टाइल संयोजन तुरंत लागू करने के लिए टेम्पलेट पर क्लिक करें।',
    downloadFormat: 'डाउनलोड फॉर्मेट',
    fgBgIdentical: 'अग्रभूमि और पृष्ठभूमि रंग एक जैसे हैं — QR कोड अदृश्य होगा!',
    fgBgSimilar: 'अग्रभूमि और पृष्ठभूमि रंग बहुत समान हैं — QR कोड स्कैन करना कठिन हो सकता है।',
    preview: 'प्रीव्यू',
    angle: 'कोण',
    downloadFormatBtn: '{format} डाउनलोड करें',
    pngDesc: 'लॉसलेस, ट्रांसपेरेंसी सपोर्ट',
    jpgDesc: 'लोकप्रिय/सार्वभौमिक फ़ाइल प्रारूप',
    webpDesc: 'आधुनिक फॉर्मेट, बेहतरीन गुणवत्ता/आकार अनुपात',
    svgDesc: 'स्केलेबल वेक्टर ग्राफिक्स',
    pdfDesc: 'प्रिंट के लिए तैयार दस्तावेज़',
    lat: 'अक्षांश:',
    lng: 'देशांतर:',
    qrCode: 'QR कोड',
    scanMe: 'स्कैन करें',
    scanHere: 'यहाँ स्कैन करें',
    blog: {
      card1: {
        title: '1. QR कोड क्या है?',
        intro1: 'QR का पूरा नाम “Quick Response” है। इसमें मौजूद जानकारी बहुत तेज़ी से पढ़ी जा सकती है।',
        intro2: 'QR कोड एक दो-आयामी डिजिटल कोड है जिसे मशीन पढ़ती है। इसमें टेक्स्ट, संपर्क, लिंक, मैप लोकेशन जैसी जानकारी रखी जा सकती है।',
        inventionTitle: 'QR कोड का आविष्कार कैसे हुआ:',
        inventionText: 'QR कोड 1994 में Masahiro Hara और उनकी टीम ने जापान की कंपनी Denso Wave में बनाया। उद्देश्य था सामान्य बारकोड से अधिक डेटा स्टोर करना।',
        keyFeaturesTitle: 'QR कोड की मुख्य विशेषताएँ',
        keyFeatures: [
          {
            title: 'QR कैसे काम करता है',
            text: 'आप टेक्स्ट या लिंक डालते हैं और सिस्टम उसे वर्गों के पैटर्न में बदल देता है। हर मॉड्यूल डेटा बिट को दर्शाता है।',
          },
          {
            title: 'QR कोड की संरचना',
            text: 'इसमें दिशा पहचानने के लिए बड़े मार्कर होते हैं और डेटा रखने के लिए छोटे मॉड्यूल होते हैं।',
          },
          {
            title: 'QR कोड की डेटा क्षमता',
            text: 'QR कोड सामान्य बारकोड से अधिक जानकारी रख सकता है। बहुत लंबा डेटा देने पर पैटर्न जटिल हो जाता है और स्कैन कठिन हो सकता है।',
          },
          {
            title: 'त्रुटि पहचान और सुधार',
            text: 'आंशिक नुकसान होने पर भी QR कोड अक्सर पढ़ा जा सकता है। एरर करेक्शन तकनीक डेटा पुनर्प्राप्ति में मदद करती है।',
          },
        ],
        errorTitle: 'QR कोड के एरर करेक्शन स्तर:',
        errorIntro: 'अलग-अलग स्थितियों के लिए अलग स्तर उपयोग किए जाते हैं:',
        errorHeaders: {
          level: 'स्तर',
          recovery: 'रिकवरी क्षमता',
          bestUse: 'सर्वोत्तम उपयोग',
        },
        errorRows: [
          {
            level: 'निम्न (L)',
            recovery: '~7%',
            useCases: [
              'डिजिटल स्क्रीन, वेबसाइट या साफ वातावरण के लिए उपयुक्त।',
              'छोटी जानकारी जैसे ईमेल, संपर्क नंबर या छोटा टेक्स्ट।',
            ],
          },
          {
            level: 'मध्यम (M)',
            recovery: '~15%',
            useCases: [
              'फ्लायर और पोस्टर जैसे सामान्य उपयोग के लिए अच्छा विकल्प।',
            ],
          },
          {
            level: 'क्वार्टाइल (Q)',
            recovery: '~25%',
            useCases: [
              'आउटडोर या कठिन वातावरण में उपयोग के लिए बेहतर।',
              'जब बीच में छोटा लोगो लगाया जाए और कुछ मॉड्यूल ढक जाएँ।',
            ],
          },
          {
            level: 'उच्च (H)',
            recovery: '~30%',
            useCases: [
              'जहाँ QR कोड के क्षतिग्रस्त होने की संभावना अधिक हो।',
              'जब QR के केंद्र में बड़ा लोगो लगाया जाए।',
              'भारी स्टाइलिंग वाले डिज़ाइन के लिए उपयुक्त।',
            ],
          },
        ],
      },
      card2: {
        title: '2. हमारा QR कोड जनरेटर क्यों चुनें?',
        intro: 'हमारा QR जनरेटर तेज़, सुरक्षित और उपयोग में आसान है। आप अपने ब्रांड के अनुसार डिज़ाइन को पूरी तरह कस्टमाइज़ कर सकते हैं।',
        strengths: [
          {
            title: 'प्रोफेशनल कस्टमाइज़ेशन:',
            text: 'बिना किसी शुल्क के जितने चाहें उतने QR कोड बनाएं और रंग, आकार, ग्रेडिएंट व अन्य विकल्पों से सजाएँ।',
          },
          {
            title: 'कई फ़ॉर्मेट का समर्थन:',
            text: 'डाउनलोड से पहले अपनी ज़रूरत का फ़ॉर्मेट चुनें। कई सामान्य फ़ॉर्मेट उपलब्ध हैं।',
          },
          {
            title: 'तैयार टेम्पलेट्स:',
            text: 'प्रोफेशनल लुक के लिए प्रीमेड रंग और फ्रेम टेम्पलेट्स का उपयोग करें।',
          },
          {
            title: 'कस्टम लोगो समर्थन:',
            text: 'अपना ब्रांड लोगो अपलोड करें या इनबिल्ट लाइब्रेरी से लोगो चुनकर QR के केंद्र में लगाएँ।',
          },
          {
            title: 'लाइव प्रीव्यू:',
            text: 'कस्टमाइज़ेशन करते समय सभी बदलाव तुरंत प्रीव्यू में दिखाई देते हैं।',
          },
          {
            title: 'स्कैन संकेतक:',
            text: 'रंग चुनते समय सिस्टम बताता है कि कौन-से संयोजन स्कैन में समस्या दे सकते हैं।',
          },
        ],
        formatHeaders: {
          srNo: 'क्रम',
          formats: 'फ़ॉर्मेट',
          description: 'विवरण',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'लॉसलेस, पारदर्शिता समर्थित' },
          { no: '2', format: 'JPG', description: 'लोकप्रिय और सार्वभौमिक फ़ाइल फ़ॉर्मेट' },
          { no: '3', format: 'WEBP', description: 'आधुनिक, बेहतर गुणवत्ता/आकार अनुपात' },
          { no: '4', format: 'SVG', description: 'स्केलेबल वेक्टर ग्राफ़िक' },
          { no: '5', format: 'PDF', description: 'प्रिंट-रेडी दस्तावेज़' },
        ],
      },
      card3: {
        title: '3. चरण-दर-चरण मार्गदर्शिका:',
        step1Intro: 'सबसे पहले QR कोड की श्रेणी चुनें, जैसे लिंक, टेक्स्ट, WiFi, संपर्क, ईमेल या मैप।',
        categories: ['लिंक / URL', 'टेक्स्ट', 'WiFi', 'संपर्क', 'Gmail', 'Google Maps'],
        step2: 'श्रेणी चुनने के बाद, संबंधित बॉक्स में अपनी जानकारी भरें।',
        step3Intro: 'फिर Generate & Customize पर क्लिक करके कस्टमाइज़ेशन पैनल खोलें। वहाँ ये विकल्प मिलते हैं:',
        options: [
          {
            title: 'स्टाइल और आकार:',
            text: 'QR के मॉड्यूल्स का आकार बदलें, जैसे राउंड, डॉट्स, हॉरिज़ॉन्टल/वर्टिकल बार आदि।',
          },
          {
            title: 'रंग:',
            text: 'बैकग्राउंड और फोरग्राउंड रंग चुनें। आप लाइनर या रेडियल ग्रेडिएंट तथा एंगल भी सेट कर सकते हैं।',
          },
          {
            title: 'फ्रेम:',
            text: 'इनबिल्ट लाइब्रेरी से उपयुक्त फ्रेम चुनें, जो QR पर स्वतः फिट हो जाता है।',
          },
          {
            title: 'लोगो:',
            text: 'QR के केंद्र में लोगो जोड़ें; अपना लोगो अपलोड करना भी समर्थित है।',
          },
          {
            title: 'टेम्पलेट्स:',
            text: 'यदि जल्दी डिज़ाइन चाहिए तो तैयार टेम्पलेट्स एक क्लिक में लागू करें।',
          },
          {
            title: 'फ़ाइल फ़ॉर्मेट:',
            text: 'डाउनलोड के लिए PNG, WEBP, SVG या PDF जैसे फ़ॉर्मेट चुनें।',
          },
          {
            title: 'QR डेटा संपादित करें:',
            text: 'कस्टमाइज़ेशन खोए बिना QR की सामग्री बदल सकते हैं।',
          },
        ],
        finalStep: 'अंत में डाउनलोड बटन दबाएँ। आपका QR कोड चुने गए फ़ॉर्मेट और सेटिंग्स के साथ तुरंत डाउनलोड हो जाएगा।',
      },
      card4: {
        title: '4. लाभ:',
        intro: 'QR कोड भौतिक दुनिया को डिजिटल अनुभव से जोड़ता है। एक स्कैन से लिंक, संपर्क या लोकेशन तुरंत साझा की जा सकती है।',
        benefits: [
          {
            title: 'दीर्घकालिक उपयोग:',
            text: 'QR कोड में सामान्यतः कोई निश्चित समाप्ति समय नहीं होता और सही डेटा के साथ लंबे समय तक उपयोगी रहता है।',
          },
          {
            title: 'ऑफ़लाइन समर्थन:',
            text: 'इंटरनेट न होने पर भी कैमरा QR पैटर्न पढ़ सकता है और उपलब्ध डेटा दिखा सकता है।',
          },
          {
            title: 'शून्य लागत:',
            text: 'बुनियादी QR निर्माण नि:शुल्क है और उपयोग के लिए अतिरिक्त शुल्क नहीं लगता।',
          },
        ],
      },
    },
  },

  qrScanner: {
    seo: {
      title: 'QR कोड स्कैनर — कैमरा या इमेज से QR कोड स्कैन करें | photremium.com',
      desc: 'कैमरा से या इमेज अपलोड करके QR कोड तुरंत स्कैन करें। तेज़, निजी और सुरक्षित।',
      keywords: 'qr स्कैनर, qr कोड स्कैन, qr रीडर',
    },
    title: 'QR कोड स्कैनर',
    desc: 'कैमरा से या इमेज अपलोड करके QR कोड तुरंत स्कैन करें। तेज़, निजी और सुरक्षित।',
    generateQrCode: 'QR कोड जनरेट करें',
    scan: 'स्कैन करें',
    cameraScanner: 'कैमरा स्कैनर',
    uploadImage: 'इमेज अपलोड करें',
    pointCamera: 'कैमरा को QR कोड की ओर करें',
    startCamera: 'कैमरा शुरू करें',
    loading: 'लोड हो रहा है…',
    dropQrImage: 'QR कोड इमेज यहां छोड़ें',
    toScan: 'स्कैन करने के लिए',
    supportedFormats: 'JPG, PNG, GIF, WEBP समर्थित',
    ctrlVPaste: 'Ctrl+V पेस्ट करने के लिए',
    scanFromGallery: 'गैलरी से स्कैन करें',
    instantScanning: 'तुरंत स्कैनिंग',
    instantScanningDesc: 'कैमरा या अपलोड की गई इमेज से रियल-टाइम QR कोड पहचान',
    private100: '100% निजी',
    private100Desc: 'सभी प्रोसेसिंग आपके ब्राउज़र में। कुछ भी अपलोड नहीं होता',
    multiFormat: 'मल्टी-फॉर्मेट',
    multiFormatDesc: 'URL, टेक्स्ट, WiFi, संपर्क, ईमेल, फोन और अधिक पहचानता है',
    accessingCamera: 'कैमरा एक्सेस हो रहा है…',
    cameraDenied: 'कैमरा एक्सेस अस्वीकृत। कृपया कैमरा अनुमति दें और पुनः प्रयास करें।',
    noCamera: 'इस डिवाइस पर कोई कैमरा नहीं मिला।',
    cameraError: 'कैमरा एक्सेस नहीं हो सका। पुनः प्रयास करें।',
    videoError: 'वीडियो प्लेबैक शुरू नहीं हो सका।',
    switchError: 'कैमरा नहीं बदल सका।',
    tryAgain: 'पुनः प्रयास करें',
    switchCamera: 'कैमरा बदलें',
    stop: 'रोकें',
    noQrFound: 'कोई QR कोड नहीं मिला',
    couldNotRead: 'इमेज पढ़ नहीं सका',
    scannerFailed: 'स्कैनर लोड नहीं हो सका',
    noQrFoundDesc: 'इमेज में कोई QR कोड नहीं पाया गया। कोई अन्य इमेज आज़माएं या कैमरा स्कैनर उपयोग करें।',
    qrScanned: 'QR कोड स्कैन हो गया!',
    openLink: 'लिंक खोलें',
    copied: 'कॉपी हो गया!',
    copy: 'कॉपी करें',
    share: 'शेयर करें',
    scanAgain: 'फिर से स्कैन करें',
    network: 'नेटवर्क',
    password: 'पासवर्ड',
    security: 'सुरक्षा',
    unknown: 'अज्ञात',
    typeText: 'टेक्स्ट',
    typeUrl: 'URL',
    typeWifi: 'WiFi नेटवर्क',
    typeContact: 'संपर्क कार्ड',
    typeEmail: 'ईमेल',
    typePhone: 'फोन नंबर',
    typeSms: 'SMS',
    typeLocation: 'स्थान',
    blog: {
      tocTitle: 'सामग्री',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. QR कोड स्कैनर क्यों उपयोग करें?',
          paragraphs: [
            'QR कोड स्कैनर मूल रूप से एक मोबाइल कैमरा है जो QR कोड में संग्रहीत जानकारी को डिकोड करता है। आपको बस कैमरा QR कोड की ओर करना है; QR कोड की दिशा चाहे जैसी भी हो, यह विशेष पैटर्न पढ़ता है, त्रुटियाँ पहचानता है, आवश्यकता होने पर त्रुटियाँ सुधारता है और उसमें मौजूद जानकारी दिखाता है।',
          ],
          listTitle: 'QR कोड स्कैनर के प्रकार:',
          bullets: [
            'वेब-आधारित QR कोड स्कैनर: आप अपने ब्राउज़र द्वारा समर्थित ऑनलाइन स्कैनर से QR कोड स्कैन कर सकते हैं। आप कैमरा या इमेज अपलोड करके जानकारी प्राप्त कर सकते हैं। ऑटो-रीडायरेक्शन और अन्य उन्नत फीचर्स के लिए आप https://photremium.com पर जा सकते हैं।',
            'मोबाइल कैमरा: कुछ आधुनिक मोबाइल में मूल कैमरा ऐप में इन-बिल्ट QR स्कैनर होता है। ये साधारण कैमरा स्कैन से ही जानकारी प्राप्त और डिकोड कर सकते हैं।',
            'ऐप्स: कुछ ऐप्स विशेष रूप से QR कोड स्कैन करने के लिए बनाए गए हैं। हालांकि, एडवांस रीडायरेक्शन और कई अन्य फीचर्स के लिए आप इस लिंक से मुफ्त ऐप इंस्टॉल कर सकते हैं: https://photremium.com।',
            'हार्डवेयर डिवाइस: QR कोड स्कैन करने के लिए कुछ हार्डवेयर डिवाइस भी बनाए जाते हैं। ये बड़े शॉपिंग मॉल में सामान की बिलिंग के लिए व्यापक रूप से उपयोग होते हैं।',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. हमारा QR कोड स्कैनर क्यों चुनें?',
          paragraphs: [
            'आप QR कोड से डिकोड किए गए कंटेंट की कॉपी से लेकर रीडायरेक्शन तक कई उन्नत फीचर्स का उपयोग कर सकते हैं। आप हमारे QR कोड स्कैनर में कई अन्य रोचक फीचर्स भी देख सकते हैं, जैसे:',
          ],
          bullets: [
            'तेज़ गति: हमारा QR कोड स्कैनर डिकोडिंग को बेहद तेज़ बनाता है। आपको केवल QR कोड स्कैन करना है, और हमारा टूल तुरंत जानकारी देता है, साथ ही टेक्स्ट/लिंक कॉपी करने, लिंक मिलने पर खोलने, या संपर्क मिलने पर ऑटो सेव करने जैसे एडवांस विकल्प देता है।',
            'इंस्टॉलेशन की ज़रूरत नहीं: हमारे QR कोड स्कैनर के लिए अलग ऐप इंस्टॉल करने की आवश्यकता नहीं है। आप इस टूल को अपने लोकल ब्राउज़र में मुफ्त उपयोग कर सकते हैं।',
            'क्रॉस-प्लेटफ़ॉर्म एक्सेस: आप इसे किसी भी डिवाइस पर उपयोग कर सकते हैं। OS संस्करण या अन्य आवश्यकताओं की चिंता नहीं। यह सभी संस्करणों और सभी डिवाइस पर समर्थित है।',
            'सभी फॉर्मेट समर्थित: QR कोड में संग्रहीत होने वाले सभी डेटा फॉर्मेट, जैसे प्लेन टेक्स्ट, WiFi, URLs, संपर्क, Gmail और Google Maps आदि, हमारे टूल में समर्थित हैं।',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. चरण-दर-चरण मार्गदर्शिका:',
          steps: [
            {
              heading: '1. सबसे पहले, QR कोड स्कैन करने का तरीका चुनें। इसे करने के लिए निम्न दो तरीके हैं:',
              subSteps: [
                {
                  heading: 'i. कैमरा तरीका',
                  paragraphs: [
                    'आप QR कोड को अपने डिवाइस कैमरा से स्कैन कर सकते हैं, चाहे आप लैपटॉप, PC, या कोई भी ऐसा डिवाइस उपयोग कर रहे हों जिसमें साधारण कैमरा हो। “कैमरा शुरू करें” बटन पर क्लिक करते ही अनुमति अनुरोध आएगा; इस साइट को QR स्कैनिंग के लिए कैमरा उपयोग की अनुमति दें। यदि आपने गलती से अस्वीकार किया है या अनुमति अनुरोध नहीं दिख रहा, तो आप ये चरण अपनाकर कैमरा एक्सेस मैन्युअली दे सकते हैं:',
                  ],
                  notes: [
                    '➔ Chrome (Android / Desktop) के लिए:',
                    '1. तीन डॉट्स पर क्लिक करें',
                    '2. Settings में जाएँ',
                    '3. (Android में यह चरण छोड़ें) Privacy and Security',
                    '4. Site Settings पर क्लिक करें',
                    '5. फिर, permissions सेक्शन में Camera पर क्लिक करें',
                    '6. हमारी साइट की URL खोजें: https://photremium.com/qr-code-scanner',
                    '7. ड्रॉपडाउन से कैमरा Allow करें।',
                    '➔ Safari (iPhone / iOS) के लिए:',
                    '1. एड्रेस बार में AA या Website Settings आइकन पर टैप करें।',
                    '2. Website Settings चुनें।',
                    '3. Camera पर टैप करें और Allow चुनें।',
                    '4. यदि फिर भी ब्लॉक है: iPhone Settings > Safari > Camera में जाएँ और Ask या Allow सेट करें।',
                  ],
                },
                {
                  heading: 'ii. गैलरी तरीका',
                  paragraphs: [
                    'आप जानकारी प्राप्त करने के लिए QR कोड की इमेज अपलोड कर सकते हैं। “गैलरी से स्कैन करें” बटन पर क्लिक करें, और फ़ाइल एक्सप्लोरर खुल जाएगा। फिर QR कोड इमेज चुनें। सभी इमेज फॉर्मेट समर्थित हैं जैसे .jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz, और .xbm आदि।',
                  ],
                },
              ],
            },
            {
              heading: '2. जब आप QR कोड चुनते हैं, सारी जानकारी प्रदर्शित हो जाती है; जिससे आप कॉपी, शेयर, या लिंक मिलने पर उसे खोल सकते हैं। यदि चाहें तो फिर से स्कैन भी कर सकते हैं।',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'QR कोड स्कैनर के लाभ:.',
          paragraphs: [
            'QR कोड स्कैनर इस डिजिटल दुनिया में कई लाभ देता है। यह भुगतान, सत्यापन, और जानकारी तक पहुँच को आसान और तेज़ बनाता है, वह भी ऑफलाइन मोड में।',
          ],
          bullets: [
            'जानकारी तक तुरंत पहुँच: QR कोड स्कैन करते ही मिलीसेकंड में जानकारी मिल जाती है। यह पैटर्न डिकोड करता है, त्रुटियाँ पहचानता है, और तुरंत सुधारता है, जिससे उपयोगकर्ता को बेहद तेज़ अनुभव मिलता है।',
            'बेहतर संचार: आज के उन्नत दौर में बैंक विवरण और उत्पाद विवरण जैसी छोटी जानकारियों के लिए तेज़ और सुरक्षित संचार की आवश्यकता है। QR कोड स्कैनर यह समस्या हल करता है क्योंकि भुगतान QR स्कैन कर के किए जाते हैं। साथ ही, लैपटॉप पर नया अकाउंट बनाते समय Google भी मोबाइल को QR से सत्यापित करता है।',
            'E-Tickets: बस स्टैंड, रेलवे स्टेशन या एयरपोर्ट पर आप लंबी लाइन में इंतज़ार किए बिना आसानी से टिकट सत्यापित कर सकते हैं। एयरपोर्ट पर कई जगह QR स्कैनर लगाए जाते हैं ताकि कतारें कम हों। इससे कर्मचारियों की आवश्यकता भी कम होती है और एयरलाइन बजट की बचत होती है।',
            'उत्पाद प्रमाणीकरण: उन्नत और प्रीमियम ब्रांड अपने उत्पाद पर QR कोड लगाते हैं। ग्राहक उस QR कोड को स्कैन करके उत्पाद की असलियत जाँच सकता है कि वह असली है या नहीं।',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'चेहरा धुंधला करें — इमेज में चेहरे ऑनलाइन छुपाएं | photremium.com',
      uploadDesc: 'AI फेस डिटेक्शन से इमेज में चेहरे अपने आप धुंधले करें। मुफ्त, तेज़ और निजी।',
      uploadKeywords: 'चेहरा धुंधला, चेहरे छुपाएं, फेस डिटेक्शन',
      workspaceTitle: 'चेहरा धुंधला करें — photremium.com',
      workspaceDesc: 'इमेज में चेहरे अपने आप धुंधले करें। 100% मुफ्त, तेज़ और निजी।',
      workspaceKeywords: 'चेहरा धुंधला',
    },
    title: 'चेहरा धुंधला करें',
    desc: 'अधिक गोपनीयता के लिए इमेज में चेहरे अपने आप पहचानें और धुंधले करें।',
    toBlurFaces: 'चेहरे धुंधले करें',
    autoDetection: 'स्वचालित पहचान',
    autoDetectionDesc: 'AI फेस रेकग्निशन तुरंत सभी चेहरे ढूंढता है',
    customBlur: 'कस्टम धुंधलापन',
    customBlurDesc: 'धुंधलेपन की तीव्रता, आकार और स्टाइल कस्टमाइज़ करें',
    private100: '100% निजी',
    private100Desc: 'सभी प्रोसेसिंग आपके ब्राउज़र में स्थानीय रूप से होती है',
    blurTools: 'धुंधला टूल',
    faces: 'चेहरे',
    faceDetection: 'फेस डिटेक्शन',
    detecting: 'पहचान हो रही है...',
    autoDetectFaces: 'चेहरे स्वचालित रूप से पहचानें',
    exitManualMode: 'मैनुअल मोड से बाहर',
    manualSelect: 'मैनुअल चयन',
    nFaceRegions: '{n} चेहरा क्षेत्र मिले',
    noFacesDetected: 'कोई चेहरा नहीं पहचाना — मैनुअल मोड उपयोग करें',
    manualHint: 'धुंधले करने के लिए क्षेत्र पर आयत खींचने के लिए क्लिक करें और खींचें।',
    blurType: 'धुंधला प्रकार',
    blur: 'धुंधला',
    emoji: 'इमोजी',
    blurIntensity: 'धुंधलापन तीव्रता',
    strength: 'शक्ति',
    blurShape: 'धुंधला आकार',
    rectangle: 'आयत',
    ellipse: 'दीर्घवृत्त',
    circle: 'वृत्त',
    chooseEmoji: 'इमोजी चुनें',
    blurRegionsN: 'धुंधला क्षेत्र ({n})',
    faceN: 'चेहरा {n}',
    manualRegionN: 'मैनुअल क्षेत्र {n}',
    manualN: 'मैनुअल {n}',
    clearAllRegions: 'सभी क्षेत्र साफ़ करें',
    processingDots: 'प्रोसेसिंग...',
    downloadBlurred: 'धुंधली इमेज डाउनलोड करें',
    downloadNImages: '{n} इमेज डाउनलोड करें',
    downloadDialogTitle: 'सभी इमेज एडिट नहीं हुईं',
    downloadDialogText: 'आपने {total} में से {edited} इमेज एडिट किए.',
    downloadAll: 'सभी डाउनलोड करें',
    removeRegion: 'क्षेत्र हटाएं',
    region: 'क्षेत्र',
    notAllEdited: 'सभी इमेज एडिट नहीं हुईं',
    editedXofY: 'आपने {total} में से {edited} इमेज एडिट किए.',
    nextImage: 'अगली इमेज',
  },

  faqData: {
    imageConverter: [
      { q: 'कौन से इमेज फ़ॉर्मेट कन्वर्ज़न के लिए समर्थित हैं?', a: 'हम JPG, PNG, WEBP, SVG, GIF, BMP, ICO और TIFF को सपोर्ट करते हैं। आप इन फ़ॉर्मेट्स के बीच अपने ब्राउज़र में तुरंत कन्वर्ट कर सकते हैं।' },
      { q: 'क्या कन्वर्ज़न के दौरान इमेज की क्वालिटी प्रभावित होगी?', a: 'PNG जैसे लॉसलेस फ़ॉर्मेट के लिए क्वालिटी पूरी तरह सुरक्षित रहती है। JPG और WEBP जैसे लॉसी फ़ॉर्मेट के लिए हम ऑप्टिमाइज़्ड एन्कोडिंग सेटिंग्स का उपयोग करते हैं।' },
      { q: 'क्या फ़ाइल साइज़ या मात्रा की कोई सीमा है?', a: 'कोई सख्त सीमा नहीं है। आप एक साथ कई इमेज अपलोड कर सकते हैं और बैच-कन्वर्ट कर सकते हैं। सब कुछ आपके ब्राउज़र में लोकली चलता है।' },
      { q: 'क्या मेरा डेटा सुरक्षित है? क्या इमेज किसी सर्वर पर अपलोड होती हैं?', a: 'बिल्कुल। सारी प्रोसेसिंग 100% आपके ब्राउज़र में होती है। आपकी इमेज कभी आपके डिवाइस से बाहर नहीं जाती।' },
      { q: 'क्या मैं ट्रांसपेरेंट PNG को JPG में कन्वर्ट कर सकता हूँ?', a: 'हाँ। चूँकि JPG ट्रांसपेरेंसी को सपोर्ट नहीं करता, इसलिए ट्रांसपेरेंट एरिया डिफ़ॉल्ट रूप से सफ़ेद बैकग्राउंड से भर जाते हैं।' },
    ],
    imageCompressor: [
      { q: 'क्या इमेज को कम्प्रेस करने से उसकी क्वालिटी घटती है?', a: 'नहीं, इमेज को कम्प्रेस करने से क्वालिटी तब तक प्रभावित नहीं होती जब तक आप सुझाई गई सीमाओं से आगे नहीं जाते। क्वालिटी संकेतक इस तरह मार्गदर्शन करते हैं: i. 1 से 40% कम्प्रेशन: हरा संकेत और “अच्छी क्वालिटी” संदेश। ii. 41 से 60% कम्प्रेशन: पीला संकेत और “सामान्य क्वालिटी” संदेश। यह रेंज अच्छे परिणामों के लिए अनुशंसित है। iii. 61 से 100% कम्प्रेशन: लाल चेतावनी और “खराब क्वालिटी” संदेश। इस रेंज में क्वालिटी में साफ़ गिरावट दिखाई दे सकती है।' },
      { q: 'कम्प्रेशन के लिए कौन-कौन से इमेज फ़ॉर्मेट सपोर्ट होते हैं?', a: 'हमारा इमेज कम्प्रेसर इन सभी फ़ॉर्मेट्स को सपोर्ट करता है:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'क्या मैं एक साथ कई इमेज कम्प्रेस कर सकता हूँ?', a: 'हाँ, बिल्कुल। अगर आपका सिस्टम सपोर्ट करता है तो आप एक साथ कई इमेज (यहाँ तक कि 100+) कम्प्रेस कर सकते हैं। क्योंकि कम्प्रेशन आपके सिस्टम के संसाधनों का उपयोग करता है, बड़े बैच के लिए बेहतर डिवाइस उपयोगी है। कम क्षमता वाले डिवाइस पर आप बैचों में कम्प्रेस कर सकते हैं—यह टूल फिर भी पूरी तरह मुफ्त है।' },
      { q: 'क्या आप हमारी इमेज को अपने सर्वर पर स्टोर या अपलोड करते हैं?', a: 'नहीं। हम आपकी इमेज को कभी अपने सर्वर पर न तो अपलोड करते हैं और न ही स्टोर करते हैं। सारी कम्प्रेशन आपके ब्राउज़र में लोकली होती है। आपकी इमेज आपके डिवाइस से बाहर नहीं जाती।' },
      { q: 'क्या यह इमेज कम्प्रेसिंग टूल मुफ्त है?', a: 'हाँ। हमारा इमेज कम्प्रेसर हमेशा के लिए पूरी तरह मुफ्त है। हम कभी भुगतान नहीं मांगते, कोई छुपे शुल्क नहीं हैं, और मल्टीपल इमेज कम्प्रेशन सहित सभी फीचर्स मुफ्त हैं।' },
    ],
    cropImage: [
      { q: 'क्या इमेज को क्रॉप करने से उसकी क्वालिटी कम होगी?', a: 'नहीं, इमेज को क्रॉप करने से इमेज की विज़ुअल क्वालिटी बिल्कुल भी प्रभावित नहीं होगी। इमेज को क्रॉप करना केवल अनचाहे हिस्सों को हटाता है। यह क्रॉप किए जाने वाले हिस्से के पिक्सेल को कभी नहीं बदलता। इसलिए, आप अपनी इमेज को मूल क्वालिटी में बिना किसी पिक्सेल डैमेज के क्रॉप कर सकते हैं।' },
      { q: 'इमेज क्रॉपर के लिए कौन-कौन से इमेज फॉर्मेट समर्थित हैं?', a: 'आप किसी भी फॉर्मेट की कोई भी इमेज चुन सकते हैं क्योंकि हमारा इमेज क्रॉपर टूल लगभग सभी इमेज फॉर्मेट प्रदान करता है। ये नीचे सूचीबद्ध हैं:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'क्या मेरी इमेज आपके सर्वर पर अपलोड होती हैं?', a: 'नहीं, पूरा प्रोसेसिंग आपके लोकल ब्राउज़र में होगा। आपकी इमेज कभी भी हमारे सर्वर पर अपलोड नहीं की जाएँगी क्योंकि वे आपके डिवाइस से बाहर नहीं जातीं। इसलिए, आप हमारे इमेज क्रॉपर से अपनी व्यक्तिगत इमेज बिना किसी जोखिम के क्रॉप कर सकते हैं।' },
      { q: 'क्या मैं एक साथ कई इमेज क्रॉप कर सकता हूँ?', a: 'हाँ, यदि आपका सिस्टम सपोर्ट करता है तो आप एक बार में कई इमेज (यहाँ तक कि 100+) क्रॉप कर सकते हैं। क्योंकि इमेज क्रॉप करने में आपके सिस्टम के संसाधन उपयोग होते हैं, इसलिए यदि आपके पास हाई-परफॉर्मेंस लैपटॉप, PC या मोबाइल है तो आप एक साथ कई इमेज क्रॉप कर सकते हैं। यदि आपके पास लो-एंड डिवाइस है, तो आप इमेज को बैच में क्रॉप कर सकते हैं क्योंकि यह टूल मुफ्त है, भले ही आप एक साथ कई इमेज क्रॉप करें।' },
      { q: 'क्या यह इमेज क्रॉपर टूल उपयोग करने के लिए मुफ्त है?', a: 'हाँ, यह इमेज क्रॉपिंग टूल हमेशा के लिए पूरी तरह मुफ्त है। आप इस टूल को कहीं भी, कभी भी और किसी भी डिवाइस पर उपयोग कर सकते हैं। आपको न केवल सभी डिवाइस के लिए responsive design मिलेगा, बल्कि किसी भी premium feature के लिए आपसे कभी भुगतान नहीं माँगा जाएगा। सभी फीचर्स पूरी तरह मुफ्त हैं और कोई hidden charges नहीं हैं।' },
    ],
    resizeImage: [
      { q: 'क्या मैं एक साथ कई इमेज रिसाइज़ कर सकता/सकती हूँ?', a: 'बिल्कुल, हमारा इमेज रिसाइज़ टूल आपको एक साथ कई इमेज रिसाइज़ करने देता है। आप अपने डिवाइस की क्षमता के अनुसार जितनी चाहें उतनी इमेज अपलोड करें, हमारा AI इंजन उन सभी को एक साथ रिसाइज़ कर देगा। लेकिन यदि आपका डिवाइस लो-एंड है, तो लैग से बचने के लिए इमेज को कई बैच में रिसाइज़ करें। सर्वर अपलोड से बचकर आपकी प्राइवेसी सुरक्षित रखने के लिए रिसाइज़िंग में डिवाइस संसाधनों का उपयोग होता है।' },
      { q: 'क्या यह इमेज रिसाइज़िंग टूल मुफ्त है?', a: 'हाँ, यह टूल हमेशा के लिए मुफ्त है। किसी भी प्रीमियम फीचर को अनलॉक करने के लिए आपसे कभी भुगतान वाली सदस्यता नहीं मांगी जाएगी। आपकी रिसाइज़ की गई इमेज डाउनलोड करने के लिए कोई छिपे हुए शुल्क नहीं हैं।' },
      { q: 'क्या इमेज रिसाइज़ करने से क्वालिटी कम हो जाती है?', a: '✅Decrease Size (downscale): इमेज का आकार घटाने से उसकी विज़ुअल क्वालिटी कम नहीं होती। बल्कि कई बार रिसाइज़ की गई इमेज मूल इमेज से अधिक शार्प दिखती है। इसलिए इमेज को छोटे आयाम में रिसाइज़ करने से क्वालिटी कम नहीं होगी।\n❌Increase Size (upscale): मूल आकार से ऊपर बढ़ाने पर इमेज की विज़ुअल क्वालिटी प्रभावित हो सकती है। प्रभाव की तीव्रता इस बात पर निर्भर करती है कि आकार कितना बढ़ाया गया है। जितना अधिक बढ़ाएँगे, उतनी अधिक क्वालिटी गिरेगी।' },
      { q: 'क्या यह इमेज रिसाइज़िंग टूल सुरक्षित है?', a: 'हाँ, हमारा इमेज रिसाइज़र पूरी तरह सुरक्षित है, खासकर आपकी निजी और व्यक्तिगत इमेज के लिए, क्योंकि आपकी सभी इमेज लोकली प्रोसेस होती हैं। प्रोसेसिंग के दौरान आपका कोई भी डेटा किसी भी रूप में डिवाइस से बाहर नहीं जाता। इसलिए आप बिना जोखिम अपनी व्यक्तिगत इमेज रिसाइज़ कर सकते हैं।' },
      { q: 'कौन-कौन से इमेज फॉर्मेट समर्थित हैं?', a: 'हमारे इमेज रिसाइज़र टूल में सभी इमेज फॉर्मेट समर्थित हैं। आप इन फॉर्मेट में इमेज चुन सकते हैं:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'बैकग्राउंड रिमूवल कैसे काम करता है?', a: 'हम एक एडवांस्ड AI मॉडल का उपयोग करते हैं जो सीधे आपके ब्राउज़र में चलता है और सब्जेक्ट को बैकग्राउंड से अलग करता है।' },
      { q: 'क्या यह जटिल बैकग्राउंड के साथ काम करता है?', a: 'हाँ। AI मॉडल कई तरह के दृश्यों को संभालता है। सबसे अच्छे परिणाम तब मिलते हैं जब सब्जेक्ट और बैकग्राउंड का कंट्रास्ट स्पष्ट हो।' },
      { q: 'क्या मैं एक साथ कई इमेज का बैकग्राउंड हटा सकता हूँ?', a: 'हाँ। कई इमेज अपलोड करें और टूल उन्हें एक-एक करके प्रोसेस करेगा। सभी परिणाम ZIP में डाउनलोड करें।' },
      { q: 'आउटपुट फ़ॉर्मेट क्या है?', a: 'आउटपुट हमेशा ट्रांसपेरेंट बैकग्राउंड वाली PNG फ़ाइल होती है।' },
      { q: 'क्या मेरी इमेज किसी सर्वर पर भेजी जाती हैं?', a: 'नहीं। AI मॉडल WebAssembly का उपयोग करके पूरी तरह आपके ब्राउज़र में चलता है।' },
    ],
    watermarkImage: [
      { q: '1. क्या Photremium वॉटरमार्क टूल पूरी तरह मुफ्त है?', a: 'हाँ, photremium.com/watermark-image पर वॉटरमार्क टूल पूरी तरह मुफ्त है, बिना अकाउंट और बिना सब्सक्रिप्शन के। आप एक इमेज पर या पूरे बैच पर वॉटरमार्क लगा सकते हैं—कोई पेवॉल नहीं, कोई ज़बरदस्ती रजिस्ट्रेशन नहीं, और कोई डाउनलोड लिमिट नहीं। यह टूल इस वजह से चलता है कि Photremium प्लेटफॉर्म कुल मिलाकर उपयोगी है, न कि बेसिक फीचर्स को बंद करके।' },
      { q: '2. मैं एक साथ कितनी इमेज पर वॉटरमार्क लगा सकता/सकती हूँ?', a: 'यह टूल कई इमेज को एक साथ बैच में वॉटरमार्क करने देता है। आप पूरा फोल्डर ड्रैग-एंड-ड्रॉप कर सकते हैं या Ctrl+Click से दर्जनों फाइलें चुन सकते हैं। बाईं तरफ थंबनेल स्ट्रिप सभी फाइलें दिखाती है, और "Watermark & Download All" पर क्लिक करते ही टूल हर इमेज को रेंडर करके ZIP में पैक करता है (या अलग-अलग फाइल के रूप में डाउनलोड करता है — आपकी पसंद). व्यावहारिक रूप से लिमिट आपके डिवाइस की मेमोरी है, कोई कृत्रिम सीमा नहीं।' },
      { q: '3. इनपुट और आउटपुट के लिए कौन से फॉर्मेट सपोर्ट होते हैं?', a: 'इनपुट में वे फॉर्मेट स्वीकार होते हैं जिन्हें आपका ब्राउज़र File API के ज़रिए पढ़ सकता है — आमतौर पर JPEG, JPG, PNG, WEBP, GIF (स्टैटिक), BMP और SVG। आउटपुट में वही फॉर्मेट रहता है: अगर आप PNG अपलोड करते हैं तो PNG मिलेगा; अगर JPEG अपलोड करते हैं तो JPEG 0.95 क्वालिटी के साथ मिलेगा। इससे लॉसलेस PNG का गलती से लॉसी JPG में बदलना नहीं होता।' },
      { q: '4. क्या अलग-अलग रेजोल्यूशन वाली इमेज में वॉटरमार्क एक जैसा दिखेगा?', a: 'हाँ, टूल के प्रोपोर्शनल री-पोजिशनिंग इंजन की वजह से। जब आप अलग-अलग डाइमेंशन वाली इमेज के बैच पर काम करते हैं, तो वॉटरमार्क रेफरेंस इमेज पर बनाया जाता है। एक्सपोर्ट के समय इंजन वॉटरमार्क लेयर की पोजिशन को रेफरेंस इमेज के केंद्र से फ्रैक्शनल ऑफसेट के रूप में कैलकुलेट करता है और वही अनुपात बाकी इमेज पर लागू करता है। साइज भी अनुपात में स्केल होता है (चौड़ाई/ऊँचाई में छोटे स्केल फैक्टर के अनुसार), ताकि लेयर इमेज के बाहर न जाए। नतीजा: पूरे बैच में वॉटरमार्क की रिलेटिव पोजिशन और साइज एक जैसा रहता है।' },
      { q: '5. क्या मैं अपने लोगो या सिग्नेचर को टेक्स्ट की जगह वॉटरमार्क बना सकता/सकती हूँ?', a: 'बिल्कुल। दाईं पैनल में "Add Image" बटन आपको अपने डिवाइस से कोई भी इमेज वॉटरमार्क लेयर के रूप में अपलोड करने देता है। ट्रांसपेरेंट बैकग्राउंड वाले PNG सबसे अच्छे रहते हैं — ट्रांसपेरेंसी बनी रहती है, इसलिए सिर्फ लोगो दिखाई देता है। आप कॉर्नर हैंडल से आकार बदल सकते हैं (एस्पेक्ट रेशियो बना रहता है), रोटेट कर सकते हैं, फ्लिप कर सकते हैं, ओपेसिटी एडजस्ट कर सकते हैं और बॉर्डर या राउंडेड कॉर्नर जोड़ सकते हैं। कई यूज़र्स वॉटरमार्क के लिए अपने लोगो का ट्रांसपेरेंट वर्ज़न तैयार रखते हैं।' },
      { q: '6. वॉटरमार्क को ट्रांसपेरेंट या सेमी-ट्रांसपेरेंट कैसे बनाऊँ?', a: 'कैनवास पर वॉटरमार्क लेयर को सेलेक्ट करें। ऊपर की टूलबार में ओपेसिटी कंट्रोल प्रतिशत के साथ दिखेगा — आप वैल्यू टाइप कर सकते हैं या स्लाइड कर सकते हैं। प्रोफेशनल और हल्के वॉटरमार्क के लिए आमतौर पर 30–50% अच्छा रहता है। ज्यादा उभरा हुआ कॉपीराइट चाहिए तो 70–80% चुनें। आप लेयर मैनेजर में आँख वाले आइकन से लेयर को टॉगल करके before/after तुलना भी कर सकते हैं।' },
      { q: '7. क्या मैं एक ही इमेज पर कई वॉटरमार्क जोड़ सकता/सकती हूँ?', a: 'हाँ — लेयर सिस्टम अनलिमिटेड वॉटरमार्क सपोर्ट करता है, और हर लेयर स्वतंत्र रूप से कॉन्फ़िगर होती है। आप नीचे दाईं तरफ कॉपीराइट टेक्स्ट, ऊपर बाईं तरफ लोगो और एक साथ "SAMPLE" टाइल्ड ओवरले भी लगा सकते हैं। हर लेयर का अपना ओपेसिटी, रोटेशन, पोजिशन, साइज और स्टाइल होता है। लेयर मैनेजर सब कुछ व्यवस्थित रखता है और बिना डिलीट किए ऑन/ऑफ करने देता है ताकि आप अलग-अलग कॉम्बिनेशन ट्राय कर सकें।' },
      { q: '8. टाइलिंग फीचर क्या करता है और कब उपयोग करना चाहिए?', a: 'टाइलिंग आपका वॉटरमार्क पूरी इमेज पर ग्रिड पैटर्न में दोहराता है। Grid 2×2 चार कॉपी रखता है, Grid 3×3 नौ कॉपी। टाइल स्पेसिंग कंट्रोल कॉपी के बीच दूरी तय करता है। यह तब उपयोगी है जब आप इमेज को बिना अनुमति उपयोग से रोकना चाहते हैं — कोने में एक वॉटरमार्क आसानी से क्रॉप हो सकता है, लेकिन पूरी सतह पर टाइल्ड पैटर्न हटाना कठिन होता है बिना क्वालिटी बिगाड़े। यह तरीका अक्सर कॉन्ट्रैक्ट प्रीव्यू, ड्राफ्ट आर्टवर्क या पेमेंट से पहले शेयर किए गए कंटेंट में इस्तेमाल होता है।' },
      { q: '9. क्या यह टूल मोबाइल और टैबलेट पर काम करता है?', a: 'हाँ, यह टूल पूरी तरह responsive है और मोबाइल के लिए डिज़ाइन किया गया है। 900px से छोटी स्क्रीन पर तीन-पैनल लेआउट स्टैक्ड हो जाता है: थंबनेल स्ट्रिप ऊपर हॉरिज़ॉन्टल स्क्रोल बन जाती है, कैनवास बीच में रहता है, और सेटिंग्स पैनल नीचे एक बॉटम शीट के रूप में खुलता है जिसे फ्लोटिंग गियर बटन से ट्रिगर किया जाता है। सभी इंटरैक्शन — ड्रैग, रीसाइज़ हैंडल, रोटेशन — टच पर काम करते हैं। मोबाइल पर हैंडल थोड़ा बड़ा (16×16 px) रखा गया है ताकि उंगली से आसानी हो।' },
      { q: '10. क्या मेरी इमेज डेटा प्राइवेट है? क्या फोटो किसी सर्वर पर अपलोड होती हैं?', a: 'आपकी इमेज कभी भी आपके डिवाइस से बाहर नहीं जाती। पूरा वॉटरमार्किंग वर्कफ़्लो — इमेज लोड करना, लेयर रेंडर करना, और फाइनल फाइल एक्सपोर्ट करना — ब्राउज़र के अंदर JavaScript और HTML5 Canvas API से होता है। जब आप इमेज अपलोड करते हैं, File API उसे मेमोरी में लाता है। जब आप वॉटरमार्क जोड़ते हैं, वह ऑफ-स्क्रीन Canvas पर ड्रॉ होता है। डाउनलोड के समय कैनवास के पिक्सेल डेटा को Blob में बदला जाता है और ब्राउज़र उसे लोकल डाउनलोड के लिए देता है — सब कुछ लोकल। कोई नेटवर्क रिक्वेस्ट आपकी इमेज डेटा लेकर नहीं जाती। साथ ही, टूल में पेज-लीव गार्ड है: अगर आप इमेज लोड होने पर पेज बंद करते हैं, तो ब्राउज़र कन्फर्मेशन मांगता है ताकि आपका काम गलती से न खोए।' },
    ],
    qrCodeGenerator: [
      { q: 'क्या यह QR कोड एक्सपायर होता है?', a: 'नहीं, ये QR कोड एक्सपायर नहीं होते और आजीवन उपयोग के लिए उपलब्ध रहते हैं। क्योंकि इनमें जानकारी स्क्वायर बॉक्स के अंदर बिट्स के रूप में हार्डकोडेड होती है, इसलिए इसमें संग्रहीत जानकारी बदली या हटाई नहीं जा सकती। आप वर्षों बाद भी किसी भी कैमरे से स्कैन करके इसमें मौजूद जानकारी प्राप्त कर सकते हैं।' },
      { q: 'मेरा QR कोड स्कैन क्यों नहीं हो रहा?', a: 'आपका QR कोड इन कारणों से स्कैन नहीं हो सकता: i. कम कॉन्ट्रास्ट: यदि आपने बैकग्राउंड और फोरग्राउंड के बहुत मिलते-जुलते रंग चुने हैं, तो QR कोड की दृश्यता कम हो जाती है और स्कैन विफल हो सकता है। हमारा टूल कस्टमाइजेशन के दौरान लो-कॉन्ट्रास्ट और अन्य स्कैनिंग समस्याओं के बारे में चेतावनी देता है। ii. बहुत अधिक डेटा: यदि आप बहुत लंबा टेक्स्ट डालते हैं, तो QR कोड बहुत जटिल हो जाता है और स्कैन करना कठिन होता है। टेक्स्ट लंबाई वैलिडेटर आपको उपयुक्त लंबाई के बारे में मार्गदर्शन देता है। iii. धुंधला प्रिंट: QR कोड को हाई-रिज़ॉल्यूशन फॉर्मेट जैसे PNG या SVG में डाउनलोड करें, जो हमारे टूल में समर्थित हैं।' },
      { q: 'क्या मैं QR कोड में लोगो जोड़ सकता/सकती हूँ?', a: 'बिल्कुल। आप अपना कस्टम लोगो जोड़ सकते हैं या इन-बिल्ट लोगो लाइब्रेरी से कोई लोगो चुन सकते हैं। चुना हुआ लोगो QR कोड के बीच में अपने आप सही तरीके से फिट हो जाएगा।' },
      { q: 'मैं QR कोड कैसे स्कैन करूँ?', a: 'आप अपने मोबाइल कैमरे से QR कोड स्कैन कर सकते हैं। लेकिन लिंक पर ऑटोमैटिक रीडायरेक्शन और कई उन्नत फीचर्स के लिए आप https://photremium.com/qr-code-scanner पर हमारे QR कोड स्कैनर का मुफ्त उपयोग कर सकते हैं।' },
      { q: 'मैं मुफ्त में कितने QR कोड बना सकता/सकती हूँ?', a: 'असीमित! आप मुफ्त में जितने चाहें उतने QR कोड बना सकते हैं। सभी फीचर्स, कस्टमाइजेशन और टेम्पलेट्स हमेशा के लिए मुफ्त हैं। प्रीमियम फीचर्स का उपयोग करने के लिए किसी सब्सक्रिप्शन की जरूरत नहीं है।' },
      { q: 'क्या QR कोड बनाने के लिए लॉगिन/साइनअप जरूरी है?', a: 'नहीं। बस अपना टेक्स्ट दर्ज करें, QR कोड जनरेट करें और कस्टमाइज करने के बाद डाउनलोड करें। लॉगिन या साइनअप की आवश्यकता नहीं है, क्योंकि सभी फीचर्स पूरी तरह मुफ्त उपलब्ध हैं।' },
    ],
    qrCodeScanner: [
      { q: 'क्या मैं सेव की गई इमेज और स्क्रीनशॉट से QR कोड स्कैन कर सकता/सकती हूँ?', a: '**हाँ**, आप सेव की गई इमेज या स्क्रीनशॉट से QR कोड स्कैन कर सकते हैं। हमारा QR कोड स्कैनर https://photremium.com/qr-code-scanner आपको गैलरी से QR कोड स्कैन करने देता है। आपको बस इमेज चुननी है और उस QR कोड से प्राप्त सारी डिकोडेड जानकारी मिल जाएगी।' },
      { q: 'क्या QR कोड स्कैनर के लिए ऐप इंस्टॉल करना ज़रूरी है?', a: '**नहीं**, हमारा वेब-आधारित QR कोड स्कैनर बिना ऐप इंस्टॉल किए QR कोड स्कैन करने देता है। आप किसी भी डिवाइस पर हमारा एडवांस QR स्कैनर मुफ्त उपयोग कर सकते हैं।' },
      { q: 'स्कैनर QR कोड पहचान क्यों नहीं रहा?', a: 'आपका QR कोड निम्न में से किसी कारण से स्कैन नहीं हो रहा: i. अपर्याप्त रोशनी: कम रोशनी में स्कैन करने पर समस्या हो सकती है। यदि आप स्क्रीन से स्कैन कर रहे हैं तो फ्लैशलाइट चालू करें और ब्राइटनेस बढ़ाएँ। ii. दूरी: गलत दूरी से स्कैन करने पर भी समस्या होती है। QR कोड स्कैन करने की आदर्श दूरी लगभग 10 इंच (25cm) है। iii. गंदा कैमरा लेंस: गंदे लेंस के कारण भी QR स्कैन फेल हो सकता है। स्कैन से पहले लेंस साफ करें। “क्या स्कैनर में बॉक्स ग्रिड दिख रही है? QR कोड को उसके अंदर फिट करें, वह सफलतापूर्वक स्कैन हो जाएगा।”' },
      { q: 'क्या यह टूल उल्टा या रंगीन QR कोड स्कैन कर सकता है?', a: '**हाँ**, आप किसी भी रंग या दिशा में QR स्कैन कर सकते हैं। हालांकि, यदि बैकग्राउंड और फोरग्राउंड रंग का कॉन्ट्रास्ट कम है, तो स्कैन में कठिनाई हो सकती है।' },
      { q: 'क्या यह टूल मुफ्त है?', a: '**हाँ**, यह टूल पूरी तरह मुफ्त है। आप हमेशा के लिए असीमित QR कोड मुफ्त स्कैन कर सकते हैं।' },
    ],
    faceBlur: [
      { q: 'फेस डिटेक्शन कैसे काम करता है?', a: 'हम एक AI-पावर्ड फेस डिटेक्शन मॉडल का उपयोग करते हैं जो सीधे आपके ब्राउज़र में चलता है। यह इमेज में चेहरों की पहचान करता है।' },
      { q: 'क्या मैं चुन सकता हूँ कि कौन से चेहरे ब्लर करें?', a: 'हाँ। डिटेक्शन के बाद हर चेहरे का एरिया हाइलाइट होता है और आप चुन सकते हैं कि कौन से ब्लर करने हैं।' },
      { q: 'कौन से ब्लर स्टाइल उपलब्ध हैं?', a: 'आप गाउसियन ब्लर, पिक्सेलेशन या सॉलिड कलर ओवरले में से चुन सकते हैं, जिनकी इंटेंसिटी पूरी तरह एडजस्ट होती है।' },
      { q: 'क्या मैं एक साथ कई इमेज में चेहरे ब्लर कर सकता हूँ?', a: 'हाँ। कई इमेज अपलोड करें, ब्लर रीजन कॉन्फ़िगर करें और सभी प्रोसेस्ड इमेज डाउनलोड करें।' },
      { q: 'क्या मेरी फ़ोटो किसी रिमोट सर्वर पर भेजी जाती हैं?', a: 'नहीं। AI मॉडल WebAssembly का उपयोग करके आपके ब्राउज़र में चलता है। आपकी फ़ोटो कभी सर्वर पर अपलोड नहीं होती।' },
    ],
    photoEditor: [
      { q: 'कौन सी एडिटिंग सुविधाएँ उपलब्ध हैं?', a: 'आप ब्राइटनेस, कंट्रास्ट, सैचुरेशन एडजस्ट कर सकते हैं, फ़िल्टर लगा सकते हैं, टेक्स्ट, ओवरले, फ्रेम, स्टिकर जोड़ सकते हैं — सब कुछ ब्राउज़र में।' },
      { q: 'क्या मैं बदलाव अनडू और रीडू कर सकता हूँ?', a: 'हाँ। एडिटर पूर्ण अनडू/रीडू हिस्ट्री को सपोर्ट करता है।' },
      { q: 'मैं कौन से फ़ाइल फ़ॉर्मेट एडिट और एक्सपोर्ट कर सकता हूँ?', a: 'आप JPG, PNG, WEBP और अन्य सामान्य फ़ॉर्मेट एडिट कर सकते हैं। एडिट की गई इमेज को अपने पसंदीदा फ़ॉर्मेट में एक्सपोर्ट करें।' },
      { q: 'क्या एडिटर मोबाइल पर काम करता है?', a: 'हाँ। एडिटर पूरी तरह रिस्पॉन्सिव और टच-फ्रेंडली है।' },
      { q: 'क्या मेरी इमेज आपके सर्वर पर स्टोर होती हैं?', a: 'नहीं। सारी एडिटिंग लोकली होती है। आपकी इमेज कभी आपके डिवाइस से बाहर नहीं जाती।' },
    ],
  },
};

export default hi;
